/*

 - a zoom esetén csak az egész képernyő zoomol. Nemcsak az alaprajz
 - ha a másik 3 képernyőn ugrálok a pozíciókban akkor elképzehető az az eset h az alaprajzi
   pozíció - ahol a kamera épp van - nem látható a képernyőn, mert kívül esik rajta. Mindig látszani kell

*/
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import ResizeObserver from 'resize-observer-polyfill';
import SVG from 'react-inlinesvg';
import axios from 'axios';
import moment from 'moment';
import {
    has as xHas,
    isArray as xIsArray,
    isEmpty as xIsEmpty
} from 'lodash';
import numeral from 'numeral';
import styled, { css } from 'styled-components';

import config from "devextreme/core/config";

import './app-styles.scss';
import { useAuth } from './contexts/auth';
import { useA360 } from './contexts/a360';
import {
    getProjects,
    getSelectedProjectId,
    getSelectedProjectPlans,
    setProjects,
    setSelectedProjectId,
    setSelectedProjectPlans
} from './store/project';
import {
    showPlanId, setShowPlanId
} from './store/plan-data'

const pdfjsLib = require('pdfjs-dist/build/pdf');

import LoginForm from './components/login/LoginForm';
import Timeline, { TimelineItemTemplate, TimelineItemCategory } from './components/timeline/Timeline';
import TimelineLegend from './components/timeline/TimelineLegend';
import PlanViewAdvanced from './components/planview/PlanViewAdvanced';
import { Point2D, Vector2D, LineSegment2D, Ray2D } from './components/planview/PlanViewAdvanced';
import { PlanviewContextProvider, usePlanViewCtx } from './components/planview/PlanViewContext';
import useLocalStorage from './hooks/localStorage';

import { Drawer, Icon, Intent, Position, Toaster,
    Button as BpButton, MenuItem as BpMenuItem,
    Tooltip as BpTooltip,
    Alignment as BP_ALIGNMENT
} from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Select as BpSelect, ItemRenderer as BpItemRenderer } from '@blueprintjs/select';
import { SizeButton } from './components/styled/SizeButton';
import { ToolTip } from './components/styled/ToolTip';
import { ProjectSelectList, ProjectSelectListItem } from './components/styled/ProjectSelectList';
import { FloatingPaletteOpen, FloatingPaletteClosed, FloatingPaletteBase } from './components/styled/FloatingPalette.Styled';
import { Pannellum } from './components/pannellum-react-local';
import { LayoutItem, LayoutPlace } from './components/layoutitemselect/LayoutConstants';
import LayoutItemSelect from './components/layoutitemselect/LayoutItemSelect';
import TourPlayOptionsDialog from './components/tourplayer/TourPlayOptionsDialog';
import TourPlayer from './components/tourplayer/TourPlayer';
import ReactDOMServer from 'react-dom/server';

import { List } from 'devextreme-react/list';
import { Button } from 'devextreme-react/button';

import {
    AiOutlineExpand,
} from 'react-icons/ai';

import {
    BiCheck,
    BiCheckDouble,
    BiFullscreen,
    BiExitFullscreen
} from 'react-icons/bi';

import {
    BsLayers,
    BsLayersFill
} from 'react-icons/bs';

import screenfull from "screenfull";
import Hammer from "hammerjs";

const zoomExtentsIcon = ReactDOMServer.renderToString(<AiOutlineExpand />);
const iconLayerCheck = ReactDOMServer.renderToString(<BiCheck />);
const iconLayerCheckAll = ReactDOMServer.renderToString(<BiCheckDouble />);
const iconLayers = ReactDOMServer.renderToString(<BsLayersFill />);
const iconLayersOff = ReactDOMServer.renderToString(<BsLayers />);

// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;

config({
    forceIsoDateParsing: true,
});


const AppToaster = Toaster.create({
    position: Position.BOTTOM,
});


const TimelineContainer = styled.div.attrs(props => ({
    isOpen:props.isOpen || false,
    width:props.width || 'calc(100% - 16px)',
    height:props.height || '112px',
    left:props.left || '8px',
    top:props.top || '8px',
    borderRadius:props.borderRadius || '4px',
    zIndex:props.zIndex || 200,
    animationSpeed:props.animationSpeed || '0.2s'
}))`
    
    //width:24px;
    //height:24px;

    ${props => !window.isTablet && css`
        width:24px;
        height:24px;
    `}
    ${props => window.isTablet && props.isOpen && css`
        width:${props => props.width};
        height:${props => props.height};
    `}
    ${props => window.isTablet && !props.isOpen && css`
        width:24px;
        height:24px;
    `}

    left:${props => props.left};
    top:${props => props.top};
    z-index:${props => props.zIndex};
    position: absolute;
    border:1px solid rgba(21,237,205,0.9);
    border-radius: ${props => props.borderRadius};
    background-color: rgba(21,237,205,0.5);
    box-shadow: 2px 2px 6px 1px rgba(0,0,0,0.2);
    overflow: hidden;
    
    ${props => !window.isTablet && css`
        transition: all ${props => props.animationSpeed} ease-in-out;
        &:hover {
            width:${props => props.width};
            height:${props => props.height};
            background-color: rgba(21,237,205,0.07);
            border-color: rgba(21,237,205,0.2);
            transition: all ${props => props.animationSpeed} ease-in-out;
        }
        & > :nth-child(1) {
            opacity: 0;
            transition: all ${props => props.animationSpeed} ease-in-out;
        }
        &:hover > :nth-child(1) {
            opacity: 1;
            transition: all ${props => props.animationSpeed} ease-in-out;
        }
    `}
    ${props => window.isTablet && props.isOpen && css`
        & > :nth-child(1) {
            display: unset;
            opacity: 1;
            transition: all ${props => props.animationSpeed} ease-in-out;
        }
    `}
    ${props => window.isTablet && !props.isOpen && css`
        & > :nth-child(1) {
            display: none;
            opacity: 0;
            transition: all ${props => props.animationSpeed} ease-in-out;
        }
    `}
`;

const TimelineHolder = styled.div`
  //border:1px solid rgba(255,255,255,0.4);
  //background-color: rgba(255,255,255,0.25);
  //&:hover {
  //  background-color: rgba(255,255,255,0.65);
  //}
`;

const SideBarBase = styled.div`
    background-color: rgba(255,255,255,0.25);
    transition: all 0.2s ease-in-out;
    &:hover {
        background-color: rgba(255,255,255,0.58);
        transition: all 0.2s ease-in-out;
    }
`;


function AppInner(props) {

    const {
        setProjects,
        setSelectedProjectId,
        setSelectedProjectPlans,
        projects,
        selectedProjectId,
        selectedProjectPlans,

        setShowPlanId,
        showPlanId
    } = props;


    const [ layoutSplit, setLayoutSplit ] =
        __DEVELOPMENT__ ? useLocalStorage('Dashboard.Layout.LayoutSplit', { horizontal: 0.5, vertical: 0.5, })
                        : useState({ horizontal: 0.5, vertical: 0.5 });

    const [ layoutContent, setLayoutContent ] = useLocalStorage('Dashboard.Layout.LayoutContent', {
        topLeft: LayoutItem.PANORAMA_VIEWER,
        topRight: LayoutItem.PANORAMA_VIEWER,
        bottomLeft: LayoutItem.MODEL_VIEWER,
        bottomRight: LayoutItem.PLAN_VIEWER,
    });

    const layoutContentRef = useRef(layoutContent);

    const { keepalive } = useAuth();

    const {
        selectedViewpointId,
        setSelectedViewpointId
    } = usePlanViewCtx();


    const planDocumentCacheRef = useRef({});

    const planViewRef = useRef();
    const autodeskViewerRef = useRef();
    const leftPanoViewerRef = useRef();
    const rightPanoViewerRef = useRef();

    const layoutHandleRef = useRef();
    const layoutHandleHammerRef = useRef();

    const suspendSyncingViewsRef = useRef(false);
    const lastYawRef = useRef(0);
    const lastPitchRef = useRef(0);

    const resizeObserverRef = useRef();

    const dashboardDataRef = useRef({
        projectPlans:[],
        paperToModel:new DOMMatrix(),
        modelToPaper:new DOMMatrix(),
        plan: null,
        planDocument: null,
        a360model:{
            hub:null,
            project:null,
            file:null,
            derivative:null,
        },
        autodeskViewerAspectRatioWH:1,
        viewPointsModelId:0,
        refPointTransformation:[1,0,0, 0,1,0, 0,0,1, 0,0,0],
        refPointTr:new THREE.Matrix4(),

        autodeskCameraChanged:false,
        autodeskCameraChangeTimeStamp:0,
        autodeskCameraChangeTimer:-1,

        autodeskNavigationLocked:true,
    });


    const { user, logout, getProtectedResource } = useAuth();
    const { a360GetTokenInfo, a360GetProjectItem } = useA360();

    const [ redraw, setRedraw ] = useState(true);
    const [ isSideBarVisible, showSideBar ] =  useState(false);
    const [ isAutodeskViewerLocked, lockAutodeskViewer ] =  useState(true);

    const [ planDocument, setPlanDocument ] =  useState(null);
    const [ layerPalette, setLayerPalette ] = useState({
        open:false,
        layerList:[],
        visibleLayerIds:[],
        left:64,
        top:8,
        height:256,
    });

    const [ viewpointDocuments, setViewpointDocuments ] = useState([]);

    const [ hotSpots, setHotSpots ] = useState([]);

    const [ leftPanoDocumentId, setLeftPanoDocumentId ] = useState(0);
    const [ leftPanoDocumentObjURL, setLeftPanoDocumentObjURL ] = useState("");

    const [ rightPanoDocumentId, setRightPanoDocumentId ] = useState(0);
    const [ rightPanoDocumentObjURL, setRightPanoDocumentObjURL ] = useState("");

    const [ isLayoutSelectOpen, setLayoutSelectOpen ] = useState({
        topLeft: false,
        topRight: false,
        bottomLeft: false,
        bottomRight: false,
    });

    const [ isTimelineOpen, setTimelineOpen ] = useState({
        left: false,
        right: false,
    });

    const [ tours, setTours ] = useState([]);
    const [ isTourOptionsVisible, showTourOptions ] = useState(false);
    const [ tourPlayer, startTourPlayer ] = useState({
        show:false,
        tour:null,
        designRoute:[],
        panoRoute:[],
    });

    const leftTimelineContainerRef = useRef();
    const rightTimelineContainerRef = useRef();

    const forceRedraw = useCallback(() => {
        setRedraw(old => !old);
    }, []);


    const handleAutodeskCameraChange = useCallback(camera => {

        let camPos = camera.position.clone();
        let camTrg = camera.target.clone();
        let frustumPos = camPos;

        if (autodeskViewerRef.current.model) {
            try {
                camPos = camPos.applyMatrix4(dashboardDataRef.current.refPointTr);
                camTrg = camTrg.applyMatrix4(dashboardDataRef.current.refPointTr);

                camPos = camPos.applyMatrix4(autodeskViewerRef.current.model.getInverseModelToViewerTransform());
                camTrg = camTrg.applyMatrix4(autodeskViewerRef.current.model.getInverseModelToViewerTransform());

                camPos = camPos.applyMatrix4(dashboardDataRef.current.modelToPaper);
                camTrg = camTrg.applyMatrix4(dashboardDataRef.current.modelToPaper);

                frustumPos = camPos;

                if (dashboardDataRef.current.planDocument) {
                    const { width, height } = dashboardDataRef.current.planDocument.pdfPageViewport;

                    if (camPos.x < 0 || camPos.x >= width ||
                        camPos.y < 0 || camPos.y >= height)
                    {
                        const frame = [
                            new LineSegment2D(new Point2D(0, 0), new Vector2D(width, 0)),
                            new LineSegment2D(new Point2D(width, 0), new Vector2D(0, height)),
                            new LineSegment2D(new Point2D(width, height), new Vector2D(-width, 0)),
                            new LineSegment2D(new Point2D(0, height), new Vector2D(0, -height)),
                        ];
                        const cut = new Ray2D(new Point2D(camPos.x, camPos.y),
                                     new Vector2D(camTrg.x-camPos.x, camTrg.y-camPos.y));

                        const intPts =
                            frame
                                .map(l => cut.intersectWith(l))
                                .filter(ipt => ipt)
                                .map(ipt => {
                                    ipt.d = ipt.sub(cut.point);
                                    return ipt;
                                })
                        ;
                        intPts.sort((l,r) => l.d < r.d ? -1 : l.d > r.d ? 1 : 0);

                        if (intPts.length)
                            frustumPos = intPts[0];
                    }
                }
            }
            catch {}
        }

        window.frustum?.remove(2);

        if (window.drawFreeFrustumAt) {
            const avec = (new THREE.Vector3()).subVectors(camTrg, camPos).setZ(0);
            const xvec = new THREE.Vector3().setX(1);
            let angle = avec.angleTo(new THREE.Vector3().setX(1));

            const xc = xvec. x * avec.y - xvec.y * avec.x;
            if (xc < 0) angle = Math.PI * 2 - angle;

            window.frustum?.add(2, () => {
                window.drawFreeFrustumAt(
                    frustumPos.x, frustumPos.y,
                    camera.fov * dashboardDataRef.current.autodeskViewerAspectRatioWH,
                    angle * 180.0 / Math.PI,
                    false)
            });

            window.frustum?.draw();
        }
    }, []);


    const autodeskCameraChangeTimeoutCB = useCallback(() => {

        if (!dashboardDataRef.current.autodeskCameraChanged)
            return;

        const delta = Date.now() - dashboardDataRef.current.autodeskCameraChangeTimeStamp;
        if (delta >= 900) {
            dashboardDataRef.current.autodeskCameraChanged = false;

            let camPos = autodeskViewerRef.current.getCamera().position.clone();

            if (autodeskViewerRef.current.model) {
                try {
                    camPos = camPos.applyMatrix4(autodeskViewerRef.current.model.getInverseModelToViewerTransform());

                    let planData = dashboardDataRef.current.projectPlans.map( p => ({
                       id:p.id,
                       level:p.relation_data.a360model.origin.z
                    }));
                    planData.sort((l,r) => l.level > r.level ? -1 : l.level < r.level ? 1 : 0);

                    while (planData.length > 1 && planData[0].level > camPos.z)
                        planData.shift();

                    if (dashboardDataRef.current.plan.id === planData[0].id)
                        return;

                    setShowPlanId(planData[0].id);
                } catch (e) {
                }
            }
        }
    });


    const onAutodeskCameraChanged = useCallback(evt => {

        if (dashboardDataRef.current?.autodeskNavigationLocked)
            return;

        handleAutodeskCameraChange(evt.camera);

        if (!autodeskViewerRef.current.model)
            return;
        if (!autodeskViewerRef.current.model.isLoadDone(false))
            return;

        if (dashboardDataRef.current?.autodeskCameraChangeTimer > 0)
            clearTimeout(dashboardDataRef.current.autodeskCameraChangeTimer);

        if (suspendSyncingViewsRef.current)
            return;

        dashboardDataRef.current.autodeskCameraChangeTimer = 0;
        dashboardDataRef.current.autodeskCameraChangeTimeStamp = Date.now();
        dashboardDataRef.current.autodeskCameraChanged = true;

        // setTimeout(autodeskCameraChangeTimeoutCB, 1000);
    });


    const onAutodeskViewerResized = useCallback(evt => {
        if (dashboardDataRef.current) {
            dashboardDataRef.current.autodeskViewerAspectRatioWH = (evt.height > 0) ? evt.width / evt.height : 1;
        }

        // handleAutodeskCameraChange(autodeskViewerRef.current.getCamera());
    }, [])
    

    const initializeAutodeskViewer = useCallback(() => {
        return new Promise((resolve, reject) => {

            if (autodeskViewerRef.current) {
                resolve();
                return;
            }

            if (!Autodesk || !THREE) {
                reject('Autodesk and THREE are required.');
                return;
            }

            a360GetTokenInfo()
                .then((tokenInfo) => {

                    const options = {
                        env: 'AutodeskProduction',
                        api: 'derivativeV2_EU',  // for models uploaded to EMEA change this option to 'derivativeV2_EU'

                        getAccessToken: function(onTokenReady) {
                            onTokenReady(tokenInfo.accessToken, tokenInfo.expiresIn);
                        }
                    };

                    Autodesk.Viewing.Initializer(options, async function () {
                        const htmlDiv = document.getElementById('viewer');
                        autodeskViewerRef.current = new Autodesk.Viewing.GuiViewer3D(htmlDiv);
                        // autodeskViewerRef.current.debugEvents(true);

                        const startedCode = autodeskViewerRef.current.start();
                        if (startedCode > 0) {
                            autodeskViewerRef.current.finish();
                            autodeskViewerRef.current = null;

                            reject('Failed to create a Viewer: WebGL not supported.');
                            return;
                        }

                        await autodeskViewerRef.current.loadExtension('Autodesk.Viewing.SceneBuilder');

                        //if (!__DEVELOPMENT__)
                        {
                            // autodeskViewerRef.current.setNavigationLockSettings({
                            //     orbit:false,
                            //     pan:false,
                            //     zoom:false,
                            //     roll:false,
                            //     fov:true,
                            //     walk:false,
                            //     gotoview:false
                            // });
                            //autodeskViewerRef.current.setNavigationLock(isAutodeskViewerLocked);
                        }

                        autodeskViewerRef.current.addEventListener(
                            Autodesk.Viewing.CAMERA_CHANGE_EVENT,
                            onAutodeskCameraChanged);
                        autodeskViewerRef.current.addEventListener(
                            Autodesk.Viewing.VIEWER_RESIZE_EVENT,
                            onAutodeskViewerResized);

                        autodeskViewerRef.current.setSelectionColor(
                            new THREE.Color(1,0,0),
                            Autodesk.Viewing.SelectionType.MIXED
                        );


                        // autodeskViewerRef.current.addEventListener(
                        //     Autodesk.Viewing.EXTENSION_ACTIVATED_EVENT,
                        //     evt => console.log('EXTENSION_ACTIVATED_EVENT', evt));


                        autodeskViewerRef.current.addEventListener(
                            Autodesk.Viewing.EXTENSION_LOADED_EVENT,
                            evt => {
                                // console.log('EXTENSION_LOADED_EVENT', evt)
                                if (evt.extensionId === 'Autodesk.BimWalk') {
                                    autodeskViewerRef.current.setDefaultNavigationTool('bimwalk');
                                    handleLockAutodeskNavigation(isAutodeskViewerLocked);
                                }
                            });

                        resolve();
                    });
                })
                .catch((error) => {
                    console.error(error)
                    reject(error);
                })
            ;
        });
    }, []);


    const handleLockAutodeskNavigation = (lock, viewpointId) => {
        if (!autodeskViewerRef.current)
            return;

        autodeskViewerRef.current.setNavigationLock(lock);
        if (lock) {
            autodeskViewerRef.current.setNavigationLockSettings({
                orbit:false,
                pan:false,
                zoom:false,
                roll:true,
                fov:true,
                walk:false,
                gotoview:false
            });

            window.frustum?.remove(2);
            window.frustum?.draw();
            setAutocadViewerCameraToViewpoint(viewpointId);
        }
        else {
            autodeskViewerRef.current.setNavigationLockSettings({
                orbit:true,
                pan:true,
                zoom:true,
                roll:true,
                fov:true,
                walk:true,
                gotoview:true
            });
            handleAutodeskCameraChange(autodeskViewerRef.current.getCamera());
        }
        autodeskViewerRef.current.setDefaultNavigationTool('bimwalk');
    }


    const onLockAutodeskViewerClicked = useCallback(evt => {
        if (!autodeskViewerRef.current)
            return;

        lockAutodeskViewer(old => {
            const locked = !old;

            handleLockAutodeskNavigation(locked, selectedViewpointId);

            dashboardDataRef.current.autodeskNavigationLocked = locked;

            return locked;
        });

    }, [lockAutodeskViewer, selectedViewpointId]);


    const createModelPlanMatrices = (plan) => {
        if (!plan.relation_data) {
            return {
                paperToModel:new DOMMatrix(),
                modelToPaper:new DOMMatrix()
            }
        }

        const rel = plan.relation_data;

        const ldx = rel.plan.scaleEnd.x - rel.plan.scaleStart.x;
        const ldy = rel.plan.scaleEnd.y - rel.plan.scaleStart.y;

        const sf = rel.a360model.scaleLength / Math.sqrt(ldx * ldx + ldy * ldy);

        const ox = rel.plan.origin.x;
        const oy = rel.plan.origin.y;
        const ax = rel.a360model.origin.x;
        const ay = rel.a360model.origin.y;

        const mxTrans = (new THREE.Matrix4()).makeTranslation(-ox, -oy, 0);
        const mxScale = (new THREE.Matrix4()).makeScale(sf, sf, sf);
        const mxRot = (new THREE.Matrix4()).makeRotationZ(rel.plan.rotation);
        const mxTransBack = (new THREE.Matrix4()).makeTranslation(ax, ay, 0);

        const paperToModel = mxTransBack.multiply(mxRot).multiply(mxScale).multiply(mxTrans);
        const modelToPaper = (new THREE.Matrix4()).getInverse(paperToModel);

        return {
            paperToModel,
            modelToPaper
        };
    }


    const loadAutodeskViewable = useCallback((id) => {

        const onGeometryLoaded = async evt => {

            if (evt.model.isSceneBuilder()) {
            //if (evt.model.getModelId() !== 1) {
                return;
            }

            autodeskViewerRef.current.removeEventListener(
                Autodesk.Viewing.MODEL_ROOT_LOADED_EVENT,
                onGeometryLoaded
            );

            let refPointTransformation = [
                1,0,0,
                0,1,0,
                0,0,1,
                0,0,0
            ];

            try {
                const docNode = evt.model.getDocumentNode();
                const doc = docNode.getDocument();

                await doc.downloadAecModelData();

                const aec = docNode.getAecModelData();

                refPointTransformation = aec.refPointTransformation;

                // console.log('model', evt.model)
                // console.log('docNode', docNode)
                // console.log('doc', doc)
                // console.log('aecModelData', aec)
            }
            catch {
            }

            await autodeskViewerRef.current.loadExtension('Autodesk.Viewing.SceneBuilder');

            const ext = autodeskViewerRef.current.getExtension('Autodesk.Viewing.SceneBuilder');

            ext?.addNewModel({
                conserveMemory: false,
                modelNameOverride: 'My Model Name'
            })
            .then(builder => {

                dashboardDataRef.current.refPointTransformation = refPointTransformation;
                dashboardDataRef.current.viewPointsModelId = builder.model.getModelId();

                const rp = dashboardDataRef.current.refPointTransformation;
                const refPointTr = (new THREE.Matrix4()).set(
                    rp[0], rp[3], rp[6], rp[9],
                    rp[1], rp[4], rp[7], rp[10],
                    rp[2], rp[5], rp[8], rp[11],
                    0, 0, 0, 1,
                );
                const refPointTrInv = (new THREE.Matrix4()).getInverse(refPointTr);
                dashboardDataRef.current.refPointTr = refPointTr;

                builder.model.setModelTransform(autodeskViewerRef.current.model.getModelToViewerTransform());

                const unitScale = autodeskViewerRef.current.model.getUnitScale() || 1.0;

                const vpMaterial = new THREE.MeshBasicMaterial({
                    color: new THREE.Color(0.2, 1, 0.2)
                });
                const vpZeroMaterial = new THREE.MeshBasicMaterial({
                    color: new THREE.Color(1, 0, 1)
                });

                (dashboardDataRef.current.projectPlans || []).forEach(pp => {
                    const tr = new DOMMatrix(pp.viewpoint_trafo);

                    const { paperToModel } = createModelPlanMatrices(pp);

                    const viewpoints = pp.viewpoints.map( vp => {
                        const vpPaper = (new DOMPoint(vp.x, vp.y)).matrixTransform(tr);

                        const vpModel = (new THREE.Vector3(vpPaper.x, vpPaper.y, 0)).applyMatrix4(paperToModel);
                        vpModel.z = pp.relation_data.a360model.origin.z + 1.6 / unitScale;
                        vpModel.applyMatrix4(refPointTrInv);

                        vpModel.id = vp.id;
                        vpModel.name = vp.name;
                        return vpModel;
                    });

                    if (__DEVELOPMENT__) {
                        const vpModel = new THREE.Vector3(0,0,0);
                        //vpModel.applyMatrix4(refPointTrInv);
                        // console.log('vpZero', vpModel)

                        const zero = new THREE.Vector3(vpModel.x, vpModel.y, vpModel.z);
                        zero.id = -1;
                        zero.name = "origin";
                        viewpoints.unshift(zero);

                        const zero0 = new THREE.Vector3(-rp[9], -rp[10], -rp[11]);
                        zero0.id = -2;
                        zero0.name = "origin";
                        viewpoints.unshift(zero0);
                    }

                    viewpoints.forEach(vp => {

                        const sphere = new THREE.BufferGeometry().fromGeometry(new THREE.SphereGeometry(0.15 / unitScale, 16, 16));
                        const transform = new THREE.Matrix4().compose(
                            new THREE.Vector3(vp.x, vp.y, vp.z),
                            new THREE.Quaternion(0, 0, 0, 1),
                            new THREE.Vector3(1, 1, 1)
                        );

                        const frag = builder.addFragment(sphere, vp.id < 0 ? vpZeroMaterial : vpMaterial, transform);
                        builder.changeFragmentsDbId(frag, vp.id);

                    });

                });
                //
                // autodeskViewerRef.current.select(
                //     [1948],
                //     dashboardDataRef.current.viewPointsModelId,
                //     Autodesk.Viewing.SelectionType.MIXED);
            })
            ;
        };

        return new Promise((resolve, reject) => {

            if (!autodeskViewerRef.current) {
                reject();
                return;
            }


            const models = autodeskViewerRef.current.impl.modelQueue().getModels();
            for (const model of models) {
                autodeskViewerRef.current.impl.unloadModel(model);
            }


            async function onDocumentLoadSuccess(viewerDocument) {
                const rootNode = viewerDocument.getRoot();
                const defaultModel = viewerDocument.getRoot().getDefaultGeometry();

                // autodeskViewerRef.current.addEventListener(
                //     Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
                //     onGeometryLoaded
                // );

                autodeskViewerRef.current.addEventListener(
                    Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT, evt => {

                    const sel = evt.selections.find(s => s.model.getModelId() === dashboardDataRef.current.viewPointsModelId);
                    if (sel && sel.dbIdArray?.length) {
                        setSelectedViewpointId(sel.dbIdArray[0]);
                    }
                });

                try {
                    // await viewerDocument.downloadAecModelData();
                }
                catch (e) {
                    console.error(e)
                }

                autodeskViewerRef.current.loadDocumentNode(viewerDocument, defaultModel, {
                    applyRefPoint:true,
                });

                resolve();
            }


            function onDocumentLoadFailure() {
                console.error('Failed fetching Forge manifest');
                reject('Failed fetching Forge manifest');
            }

            autodeskViewerRef.current.addEventListener(
                Autodesk.Viewing.MODEL_ROOT_LOADED_EVENT,
                onGeometryLoaded
            );

            Autodesk.Viewing.Document.load(
                `urn:${id}`,
                onDocumentLoadSuccess,
                onDocumentLoadFailure);

        });
    }, []);


    const onYawChanged = useCallback((yaw, vps, selectedVp) => {
        if (window.drawFrustum) {
            const selected = vps.find(vp => vp.id === selectedVp);
            if (selected) {
                window.drawFrustum(selected.x, selected.y, 75, yaw, false);
            }
        }

    }, []);


    const onPanoYawChanged = useCallback((yaw) => {
        onYawChanged(yaw, dashboardDataRef.current.planDocument.pdfViewpoints, selectedViewpointId);
    }, [selectedViewpointId]);


    const propagateHotSpots = useCallback((panellumRef, hotSpots) => {
        const viewer = panellumRef.getViewer();

        hotSpots.forEach(hs => {
            let className = "pano-hotspot";

            viewer.addHotSpot({
                ...hs,
                cssClass:`${className} pnlm-sprite`,
                clickHandlerFunc: () => setSelectedViewpointId(hs.id)
            });
        });
    }, [setSelectedViewpointId]);


    const updateAutocadViewerCameraTarget = useCallback((yaw, pitch, hfovDegrees) => {
        if (autodeskViewerRef.current) {
            const viewerElement = document.getElementById('viewer');
            if (viewerElement && viewerElement.style.visibility !== 'hidden')
            {
                const { width, height } = autodeskViewerRef.current?.canvas || {width:0,height:0};
                const fov = (width > 0) ? hfovDegrees * height / width : 45;

                let tpitch = pitch;
                if (tpitch <= -70)
                    tpitch = 70;
                else if (tpitch > 70)
                    tpitch = 70;

                const e = new THREE.Euler(0,-tpitch*Math.PI/180,yaw*Math.PI/180,'ZYX');
                const m = (new THREE.Matrix4()).makeRotationFromEuler(e);
                const ax = new THREE.Vector3();
                const ay = new THREE.Vector3();
                const az = new THREE.Vector3();
                m.extractBasis(ax, ay, az);

                const camera = autodeskViewerRef.current.getCamera().clone();
                const target = camera.position.clone();
                target.add(ax.multiplyScalar(1000));

                autodeskViewerRef.current.navigation.setView(
                    camera.position,
                    target
                );
                autodeskViewerRef.current.navigation.setVerticalFov(fov, false);
                autodeskViewerRef.current.navigation.setCameraUpVector(new THREE.Vector3(0, 0, 1));
            }
        }
    }, []);


    const setAutocadViewerCameraToViewpoint = useCallback(viewpointId => {

        if (!autodeskViewerRef.current)
            return;
        if (!viewpointId)
            return;

        const rp = dashboardDataRef.current.refPointTransformation;
        const refPointTr = (new THREE.Matrix4()).set(
            rp[0], rp[3], rp[6], rp[9],
            rp[1], rp[4], rp[7], rp[10],
            rp[2], rp[5], rp[8], rp[11],
            0, 0, 0, 1,
        );
        const refPointTrInv = (new THREE.Matrix4()).getInverse(refPointTr);

        const unitScale = autodeskViewerRef.current.model.getUnitScale() || 1.0;

        const vp = dashboardDataRef.current.plan.viewpoints.find(v => v.id === viewpointId);
        const vpTr = new DOMMatrix(dashboardDataRef.current.plan.viewpoint_trafo);

        const vpPaper = (new DOMPoint(vp.x, vp.y)).matrixTransform(vpTr);

        const vpModel = (new THREE.Vector3(vpPaper.x, vpPaper.y, 0)).applyMatrix4(dashboardDataRef.current.paperToModel);
        vpModel.z = dashboardDataRef.current.plan.relation_data.a360model.origin.z + 1.8 / unitScale;
        vpModel.applyMatrix4(refPointTrInv);


        const camtrg = new THREE.Vector3(vpModel.x, vpModel.y + 100, vpModel.z);
        autodeskViewerRef.current.navigation.setView(
            vpModel.applyMatrix4(autodeskViewerRef.current.model.getModelToViewerTransform()),
            camtrg.applyMatrix4(autodeskViewerRef.current.model.getModelToViewerTransform())
        );
        autodeskViewerRef.current.navigation.setCameraUpVector(new THREE.Vector3(0, 0, 1));



        const d = (dashboardDataRef.current.plan?.direction || 0) * 180.0 / Math.PI;

        let tyaw = 360 - (lastYawRef.current + d - 90);
        while (tyaw >= 360) tyaw -= 360;

        const panoViewer = leftPanoViewerRef.current.getViewer();

        updateAutocadViewerCameraTarget(tyaw, lastPitchRef.current, panoViewer.getHfov());

    }, []);


    const onLeftPanoramaRender = useCallback(() => {
        if (suspendSyncingViewsRef.current)
            return;
        if (!leftPanoViewerRef.current)
            return;

        suspendSyncingViewsRef.current = true;

        const panoViewer = leftPanoViewerRef.current.getViewer();

        lastYawRef.current = panoViewer.getYaw();
        lastPitchRef.current = panoViewer.getPitch();

        if (rightPanoViewerRef.current) {
            rightPanoViewerRef.current.getViewer().lookAt(
                panoViewer.getPitch(),
                lastYawRef.current,
                panoViewer.getHfov(),
                false
            );
        }

        window.frustum.remove(1);

        const d = (dashboardDataRef.current.plan?.direction || 0) * 180.0 / Math.PI;

        let tyaw = 360 - (lastYawRef.current + d - 90);
        while (tyaw >= 360) tyaw -= 360;

        if (dashboardDataRef.current?.autodeskNavigationLocked)
            updateAutocadViewerCameraTarget(tyaw, lastPitchRef.current, panoViewer.getHfov());

        window.frustum.add(1, () => {
            onPanoYawChanged(tyaw);
        });

        window.frustum.draw();

        suspendSyncingViewsRef.current = false;
    }, [onPanoYawChanged]);


    const onRightPanoramaRender = useCallback(() => {
        if (suspendSyncingViewsRef.current)
            return;
        if (!leftPanoViewerRef.current)
            return;

        suspendSyncingViewsRef.current = true;

        const panoViewer = rightPanoViewerRef.current.getViewer();

        lastYawRef.current = panoViewer.getYaw();
        lastPitchRef.current = panoViewer.getPitch();

        if (leftPanoViewerRef.current) {
            leftPanoViewerRef.current.getViewer().lookAt(
                panoViewer.getPitch(),
                lastYawRef.current,
                panoViewer.getHfov(),
                false
            );
        }

        window.frustum.remove(1);

        const d = (dashboardDataRef.current.plan?.direction || 0) * 180.0 / Math.PI;

        let tyaw = 360 - (lastYawRef.current + d - 90);
        while (tyaw >= 360) tyaw -= 360;

        if (dashboardDataRef.current?.autodeskNavigationLocked)
            updateAutocadViewerCameraTarget(tyaw, lastPitchRef.current, panoViewer.getHfov());

        window.frustum.add(1, () => {
            onPanoYawChanged(tyaw);
        });

        window.frustum.draw();

        suspendSyncingViewsRef.current = false;
    }, [onPanoYawChanged]);


    useEffect(() => {

        if (!user)
            return;

//        getProtectedResource(`/dashboard/projects`)
        getProtectedResource(`/dashboard.php?task=projects`)
            .then(response => {
                console.log(response);
                if (!xHas(response, 'data.data') ||
                    !xIsArray(response.data.data) ||
                    response.data.data.length === 0) {
                    logout();
                    AppToaster.show({
                        message:'** There are no properly configured projects.',
                        intent:Intent.DANGER
                    });
                }
                else {
                    setProjects(response.data.data);
                    if (response.data.data.findIndex(p => p.id === selectedProjectId) < 0)
                        selectedProjectId(0);
                    setSelectedProjectPlans(null);
                    dashboardDataRef.current.projectPlans = [];
                }
            })
            .catch(err => {

            })
        ;
    }, [user]);


    useEffect(() => {

        if (selectedProjectId === 0) {
            setSelectedProjectPlans(null);
            dashboardDataRef.current.projectPlans = [];
            return;
        }

        Promise.all([
                getProtectedResource(`/dashboard.php?task=plans&project=${selectedProjectId}`),
                getProtectedResource(`/tour.php?toursOf&pid=${selectedProjectId}`)
                //getProtectedResource(`/dashboard/plans/${selectedProjectId}`),
                //getProtectedResource(`/dashboard/tours/${selectedProjectId}`)
        ])
            .then(response => {

                const [ plansResponse, toursResponse ] = response;

                if (!xHas(plansResponse, 'data.data') ||
                    !xIsArray(plansResponse.data.data) ||
                    plansResponse.data.data.length)
                {
                    setSelectedProjectPlans(plansResponse.data.data);
                    dashboardDataRef.current.projectPlans = plansResponse.data.data;

                    setTours(toursResponse.data.projectTours);
                }
            })
            .catch(err => {

            })
        ;

    }, [selectedProjectId, setSelectedProjectPlans, setTours])


    useEffect(() => {
        if (!selectedProjectPlans || !xIsArray(selectedProjectPlans))
            return;

        if (selectedProjectPlans.length > 0) {
            setShowPlanId(selectedProjectPlans[0].id);
        }

    }, [selectedProjectPlans]);


    useEffect(() => {

        keepalive();

        const createMatrices = () => {
            
            if (showPlanId <= 0 || xIsEmpty(selectedProjectPlans)) {
                dashboardDataRef.current.paperToModel = new DOMMatrix();
                dashboardDataRef.current.modelToPaper = new DOMMatrix();
                return;
            }

            const plan = selectedProjectPlans.find(p => p.id === showPlanId);

            const { paperToModel, modelToPaper } = createModelPlanMatrices(plan);

            dashboardDataRef.current.paperToModel = paperToModel;
            dashboardDataRef.current.modelToPaper = modelToPaper;
        }


        const resetPano = () => {
            setSelectedViewpointId(0);
            setLeftPanoDocumentId(0);
            setRightPanoDocumentId(0);
        }


        if (showPlanId > 0) {
            const plan = selectedProjectPlans.find(p => p.id === showPlanId);

            if (!xHas(planDocumentCacheRef.current, showPlanId)) {
                getProtectedResource(`/dashboard.php?task=document&document=${showPlanId}`, 'arraybuffer')
                //getProtectedResource(`/dashboard/document/${showPlanId}`, 'arraybuffer')
                //getProtectedResource(`/dashboard/document/${showPlanId}`)
                    .then(content => {
                        const loadingTask = pdfjsLib.getDocument(content.data);

                        loadingTask.promise
                            .then(async function (pdfDocument) {
                                const optionals = await pdfDocument.getOptionalContentConfig();

                                return pdfDocument.getPage(plan.page_index).then(function (page) {
                                    const pageViewport = page.getViewport({ scale:1, offsetX:0, offsetY:0 });

                                    const vps = plan.viewpoints.map( vp => {
                                        const dvp = new DOMPoint(vp.x, vp.y);
                                        dvp.id = vp.id;
                                        dvp.name = vp.name;
                                        return dvp;
                                    });

                                    planDocumentCacheRef.current[showPlanId] = {
                                        pdfDocumentId:showPlanId,
                                        pdfDocument:pdfDocument,
                                        pdfPage:page,
                                        pdfPageViewport:pageViewport,
                                        pdfOptionalContentConfig:optionals,
                                        pdfVisibleGroups:[],
                                        pdfViewpoints:vps,
                                        pdfTransform:new DOMMatrix(plan.viewpoint_trafo),
                                        pdfLayerList:[],
                                    };

                                    dashboardDataRef.current.planDocument = planDocumentCacheRef.current[showPlanId];
                                    dashboardDataRef.current.plan = plan;

                                    createMatrices();

                                    if (optionals) {
                                        const order = optionals.getOrder();
                                        if (order && order.length) {
                                            const groups = order.map(id => ({
                                                id:id,
                                                name:optionals.getGroup(id).name,
                                            }));

                                            planDocumentCacheRef.current[showPlanId].pdfLayerList = groups;

                                            let idx = groups.findIndex(g => g.name.toLowerCase() === 'STORE_design'.toLowerCase());
                                            if (idx < 0)
                                                idx = groups.findIndex(g => g.name.toLowerCase() === 'Store Design'.toLowerCase());
                                            if (idx >= 0)
                                                planDocumentCacheRef.current[showPlanId].pdfVisibleGroups = [groups[idx].id];
                                            else
                                                planDocumentCacheRef.current[showPlanId].pdfVisibleGroups = groups.map(g => g.id);
                                        }
                                    }

                                    setPlanDocument(planDocumentCacheRef.current[showPlanId]);
                                    setLayerPalette(old => ({
                                        ...old,
                                        layerList:planDocumentCacheRef.current[showPlanId].pdfLayerList,
                                        visibleLayerIds:planDocumentCacheRef.current[showPlanId].pdfVisibleGroups
                                    }));

                                    resetPano();
                                });
                            })
                            .catch(function (reason) {
                                console.error("Error: " + reason);
                                console.trace();
                            });

                    })
                    .catch(err => {
                        console.log(err)
                    })
                ;
            }
            else {
                dashboardDataRef.current.planDocument = planDocumentCacheRef.current[showPlanId];
                dashboardDataRef.current.plan = plan;

                createMatrices();

                setPlanDocument(planDocumentCacheRef.current[showPlanId]);
                setLayerPalette(old => ({
                    ...old,
                    layerList:planDocumentCacheRef.current[showPlanId].pdfLayerList,
                    visibleLayerIds:planDocumentCacheRef.current[showPlanId].pdfVisibleGroups
                }));

                resetPano();
            }
        }
        else {
            dashboardDataRef.current.planDocument = null;
            dashboardDataRef.current.plan = null;

            createMatrices();

            setPlanDocument(null);
            resetPano();
        }
    }, [showPlanId]);


    useEffect(() => {
        if (!planDocument)
            return;

        if (autodeskViewerRef.current?.model) {
            // handleAutodeskCameraChange(autodeskViewerRef.current.getCamera());
        }

        window.frustum?.draw();

        const projectPlan = selectedProjectPlans.find(p => p.id === planDocument.pdfDocumentId);

        const viewerElement = document.getElementById('viewer');

        if (projectPlan)
        {
            if (!projectPlan.a360_hub)
            {
                if (viewerElement)
                    viewerElement.style.visibility = "hidden";
                return;
            }
            if (dashboardDataRef.current?.a360model?.hub === projectPlan.a360_hub &&
                dashboardDataRef.current?.a360model?.project === projectPlan.a360_project &&
                dashboardDataRef.current?.a360model?.file === projectPlan.a360_file)
            {
                return;
            }
        }
        else
        {
            if (viewerElement)
                viewerElement.style.visibility = "hidden";
            return;
        }

        if (viewerElement)
            viewerElement.style.visibility = "visible";
        initializeAutodeskViewer()
            .then(() => {

                const perspectiveCamera = () => {
                    autodeskViewerRef.current.autocam.homeVector.isPerspective = true;
                    autodeskViewerRef.current.autocam.homeVector.isOrtho = false;
                    autodeskViewerRef.current.autocam.originalHomeVector.isPerspective = true;
                    autodeskViewerRef.current.autocam.originalHomeVector.isOrtho = false;
                    autodeskViewerRef.current.autocam.toPerspective();

                    autodeskViewerRef.current.removeEventListener(
                        Autodesk.Viewing.MODEL_ROOT_LOADED_EVENT,
                        perspectiveCamera
                    );
                }

                autodeskViewerRef.current.addEventListener(
                    Autodesk.Viewing.MODEL_ROOT_LOADED_EVENT,
                    perspectiveCamera
                );


                a360GetProjectItem(projectPlan.a360_project, projectPlan.a360_file)
                    .then(response => {

                        const item = response.data.data;
                        const versions = response.data.included;

                        const tip = xHas(item, 'relationships.tip.data') ? item.relationships.tip.data : null;
                        const version = versions.find(v => v.id === tip.id);

                        const derivative = version.relationships.derivatives.data.id;

                        loadAutodeskViewable(derivative)
                            .then(() => {
                                dashboardDataRef.current.a360model.hub = projectPlan.a360_hub;
                                dashboardDataRef.current.a360model.project = projectPlan.a360_project;
                                dashboardDataRef.current.a360model.file = projectPlan.a360_file;
                                dashboardDataRef.current.a360model.derivative = derivative;
                            })
                            .catch(err => console.error(err))
                        ;
                    })
                    .catch(err => console.error(err))
                ;
            })
            .catch(err => AppToaster.show({
                message:'** ' + err,
                intent:Intent.DANGER
            }))
        ;

    }, [planDocument]);


    useEffect(() => {

        keepalive();

        if (autodeskViewerRef.current)
        try {
            const model = autodeskViewerRef.current.getVisibleModels().find(m => m.getModelId() === dashboardDataRef.current.viewPointsModelId);

            autodeskViewerRef.current.select(
                [ selectedViewpointId ],
                model,
                Autodesk.Viewing.SelectionType.MIXED
            );

            if (dashboardDataRef.current?.autodeskNavigationLocked)
            {
                setAutocadViewerCameraToViewpoint(selectedViewpointId);
                // const rp = dashboardDataRef.current.refPointTransformation;
                // const refPointTr = (new THREE.Matrix4()).set(
                //     rp[0], rp[3], rp[6], rp[9],
                //     rp[1], rp[4], rp[7], rp[10],
                //     rp[2], rp[5], rp[8], rp[11],
                //     0, 0, 0, 1,
                // );
                // const refPointTrInv = (new THREE.Matrix4()).getInverse(refPointTr);
                //
                // const unitScale = autodeskViewerRef.current.model.getUnitScale() || 1.0;
                //
                // const vp = dashboardDataRef.current.plan.viewpoints.find(v => v.id === selectedViewpointId);
                // const vpTr = new DOMMatrix(dashboardDataRef.current.plan.viewpoint_trafo);
                //
                // const vpPaper = (new DOMPoint(vp.x, vp.y)).matrixTransform(vpTr);
                //
                // const vpModel = (new THREE.Vector3(vpPaper.x, vpPaper.y, 0)).applyMatrix4(dashboardDataRef.current.paperToModel);
                // vpModel.z = dashboardDataRef.current.plan.relation_data.a360model.origin.z + 1.8 / unitScale;
                // vpModel.applyMatrix4(refPointTrInv);
                //
                //
                // const camtrg = new THREE.Vector3(vpModel.x, vpModel.y + 100, vpModel.z);
                // autodeskViewerRef.current.navigation.setView(
                //     vpModel.applyMatrix4(autodeskViewerRef.current.model.getModelToViewerTransform()),
                //     camtrg.applyMatrix4(autodeskViewerRef.current.model.getModelToViewerTransform())
                // );
                // autodeskViewerRef.current.navigation.setCameraUpVector(new THREE.Vector3(0, 0, 1));
            }
        }
        catch (e) {
        }

        if (selectedViewpointId < 1) {
            setViewpointDocuments([]);
            return ;
        }

        getProtectedResource(`/viewer.php?documentsat&vpid=${selectedViewpointId}`, 'json')
            .then(documents => {
                const viewpointDocs = xIsArray(documents.data.data) ? documents.data.data : [];
                viewpointDocs.sort((a, b) => {
                    const da = new Date(a.upload_at);
                    const db = new Date(b.upload_at);
                    return da < db ? -1 : (db < da ? 1 : 0);
                });

                //
                let leftId = 0;
                let rightId = 0;
                if (viewpointDocs.length === 1) {
                    leftId = viewpointDocs[0].id;
                    rightId = viewpointDocs[0].id;
                }
                else if (viewpointDocs.length > 1) {
                    const design = viewpointDocs
                        .filter(d => d.category_id === 3)
                        .map(d => {
                            try {
                                d.upload_at = moment(d.upload_at);
                            }
                            catch (e) {
                            }
                            return d;
                        });
                    const pano = viewpointDocs
                        .filter(d => d.category_id === 2)
                        .map(d => {
                            try {
                                d.upload_at = moment(d.upload_at);
                            }
                            catch (e) {
                            }
                            return d;
                        });
                    ;

                    if (design.length === 0) {
                        leftId = pano[pano.length - 2].id;
                        rightId = pano[pano.length - 1].id;
                    }
                    else if (pano.length === 0) {
                        leftId = design[design.length - 2].id;
                        rightId = design[design.length - 1].id;
                    }
                    else {
                        let today = moment();
                        while (design.length > 1) {
                            if (design[design.length-1].upload_at <= today)
                                break;
                            design.pop();
                        }
                        while (pano.length > 1) {
                            if (pano[pano.length-1].upload_at <= today)
                                break;
                            pano.pop();
                        }

                        leftId = design[design.length - 1].id;
                        rightId = pano[pano.length - 1].id;
                    }
                }

                //
                let hotSpots = [];
                const plan = dashboardDataRef.current.projectPlans.find(pp => pp.id == dashboardDataRef.current.planDocument.pdfDocumentId);
                const selectedVP = plan.viewpoints.find(vp => vp.id === selectedViewpointId);
                const nearBy = plan.viewpoints.filter(vp => {
                    if (!vp || !selectedVP)
                        return false;
                    if (vp.id === selectedVP.id)
                        return false;
                    const dx = selectedVP.x - vp.x;
                    const dy = selectedVP.y - vp.y;
                    return Math.sqrt(dx * dx + dy * dy) <= plan.navigation_radius;
                });
                nearBy.sort((vpl, vpr) => vpl.name.toLowerCase() < vpr.name.toLowerCase() ? -1 :
                                          vpl.name.toLowerCase() > vpr.name.toLowerCase() ? 1 : 0);
                hotSpots = nearBy.map(vp => {
                    const dx = vp.x - selectedVP.x;
                    const dy = vp.y - selectedVP.y;
                    const dz = -0.5;
                    const l = Math.sqrt(dx * dx + dy * dy);
                    const ya = Math.PI / 2.0 - Math.atan2(dy, dx);
                    //const ya = Math.PI - (Math.atan2(dy, dx) + Math.PI / 2.0);
                    const pi = Math.atan2(dz, l);
                    return {
                        pitch:pi * 180.0 / Math.PI,
                        yaw:(ya - plan.direction) * 180.0 / Math.PI,
                        id:vp.id,
                        text:vp.name,
                        type:''
                    };
                });

                setViewpointDocuments(viewpointDocs);
                setHotSpots(hotSpots);

                setLeftPanoDocumentId(leftId);
                setRightPanoDocumentId(rightId);
            })
            .catch(err => {
                console.log(err)
            })
        ;

    }, [selectedViewpointId]);


    useEffect(() => {
        if (leftPanoDocumentId > 0) {
            getProtectedResource(`/viewer.php?content&did=${leftPanoDocumentId}`, 'arraybuffer')
            //getProtectedResource(`/dashboard/document/${leftPanoDocumentId}`, 'arraybuffer')
                .then(content => {
                    const blob = new Blob([ content.data ]);
                    const url = URL.createObjectURL(blob);
                    setLeftPanoDocumentObjURL(url);
                })
                .catch(err => {
                    console.log(err)
                })
            ;
        }
        else {
            setLeftPanoDocumentObjURL('');
        }
        if (window.isTablet) {
            setTimelineOpen({ left:false, right:false });
        }
    }, [leftPanoDocumentId, setTimelineOpen]);


    useEffect(() => {
        if (rightPanoDocumentId > 0) {
            getProtectedResource(`/viewer.php?content&did=${rightPanoDocumentId}`, 'arraybuffer')
            //getProtectedResource(`/dashboard/document/${rightPanoDocumentId}`, 'arraybuffer')
                .then(content => {
                    const blob = new Blob([ content.data ]);
                    const url = URL.createObjectURL(blob);
                    setRightPanoDocumentObjURL(url);
                })
                .catch(err => {
                    console.log(err)
                })
            ;
        }
        else {
            setRightPanoDocumentObjURL('');
        }
        if (window.isTablet) {
            setTimelineOpen({ left:false, right:false });
        }
    }, [rightPanoDocumentId, setTimelineOpen]);


    const onLayoutHandlePan = useCallback(hammerEvt => {

        const reflow = () => {
            if (leftPanoViewerRef.current) {
                suspendSyncingViewsRef.current = true;

                const panoViewer = leftPanoViewerRef.current.getViewer();

                panoViewer.resize();

                suspendSyncingViewsRef.current = false;
            }
            if (rightPanoViewerRef.current) {
                suspendSyncingViewsRef.current = true;

                const panoViewer = rightPanoViewerRef.current.getViewer();

                panoViewer.resize();

                suspendSyncingViewsRef.current = false;
            }
            if (autodeskViewerRef.current) {
                autodeskViewerRef.current.resize();
            }
            if (planViewRef.current) {
                //planViewRef.current?.zoomExtents();
                window.frustum?.draw();
            }
        };

        if (hammerEvt.type === "pan" && hammerEvt.srcEvent) {
            const minX = window.innerWidth * 0.1;
            const maxX = window.innerWidth * 0.9;

            const minY = window.innerHeight * 0.1;
            const maxY = window.innerHeight * 0.9;

            const splitX = Math.min(Math.max(minX, hammerEvt.srcEvent.clientX), maxX)/window.innerWidth;
            const splitY = Math.min(Math.max(minY, hammerEvt.srcEvent.clientY), maxY)/window.innerHeight;

            setLayoutSplit(old => ({
                ...old,
                horizontal:splitX,
                vertical:splitY,
            }));
        }
        else if (hammerEvt.type === "panend") {
            reflow();
        }
        else if (hammerEvt.type === "doubletap") {
            setLayoutSplit(old => ({
                ...old,
                horizontal:0.5,
                vertical:0.5,
            }));
        }
    }, []);


    const closeLayoutItemSelection = useCallback(() => {
        if (window.isTablet) {
            const backdrop = document.getElementById("layout-select-backdrop");
            if (backdrop) {
                backdrop.style.display = "none";
            }

            setLayoutSelectOpen({
                topLeft:false,
                topRight:false,
                bottomLeft:false,
                bottomRight:false,
            });
            setTimelineOpen({
                left:false,
                right:false,
            });
        }
    }, [setLayoutSelectOpen, setTimelineOpen]);


    const handleLayoutItemSelection = useCallback((newLayoutPlace, newLayoutItem) => {

        const getItem = (layoutContent, layoutPlace) => {
            switch (layoutPlace) {
            case LayoutPlace.TOP_LEFT: return layoutContent.topLeft;
            case LayoutPlace.TOP_RIGHT: return layoutContent.topRight;
            case LayoutPlace.BOTTOM_LEFT: return layoutContent.bottomLeft;
            case LayoutPlace.BOTTOM_RIGHT: return layoutContent.bottomRight;
            }
            return '';
        }

        const setItem = (layoutContent, layoutPlace, layoutItem) => {
            switch (layoutPlace) {
            case LayoutPlace.TOP_LEFT:
                layoutContent.topLeft = layoutItem;
                return ;
            case LayoutPlace.TOP_RIGHT:
                layoutContent.topRight = layoutItem;
                return ;
            case LayoutPlace.BOTTOM_LEFT:
                layoutContent.bottomLeft = layoutItem;
                return ;
            case LayoutPlace.BOTTOM_RIGHT:
                layoutContent.bottomRight = layoutItem;
                return ;
            }
        }

        const findItem = (layoutContent, layoutItem) => {
            if (layoutContent.topLeft === layoutItem)
                return LayoutPlace.TOP_LEFT;
            if (layoutContent.topRight === layoutItem)
                return LayoutPlace.TOP_RIGHT;
            if (layoutContent.bottomLeft === layoutItem)
                return LayoutPlace.BOTTOM_LEFT;
            if (layoutContent.bottomRight === layoutItem)
                return LayoutPlace.BOTTOM_RIGHT;
            return '';
        }

        keepalive();

        if (window.isTablet) {
            closeLayoutItemSelection();
        }

        setLayoutContent(oldLayoutContent => {
            const currentLayoutItem = getItem(oldLayoutContent, newLayoutPlace);
            if (currentLayoutItem === newLayoutItem)
                return oldLayoutContent;

            const newData = {...oldLayoutContent};

            if (newLayoutItem !== LayoutItem.PANORAMA_VIEWER) {
                const currentPlacement = findItem(oldLayoutContent, newLayoutItem);
                setItem(newData, newLayoutPlace, newLayoutItem);
                setItem(newData, currentPlacement, currentLayoutItem);
            }
            else {
                let currentPlacement;
                switch (newLayoutPlace) {
                case LayoutPlace.TOP_LEFT:
                    if (getItem(oldLayoutContent, LayoutPlace.BOTTOM_RIGHT) === LayoutItem.PANORAMA_VIEWER)
                        currentPlacement = LayoutPlace.BOTTOM_RIGHT;
                    else if (getItem(oldLayoutContent, LayoutPlace.BOTTOM_LEFT) === LayoutItem.PANORAMA_VIEWER)
                        currentPlacement = LayoutPlace.BOTTOM_LEFT;
                    break;

                case LayoutPlace.TOP_RIGHT:
                    if (getItem(oldLayoutContent, LayoutPlace.BOTTOM_LEFT) === LayoutItem.PANORAMA_VIEWER)
                        currentPlacement = LayoutPlace.BOTTOM_LEFT;
                    else if (getItem(oldLayoutContent, LayoutPlace.BOTTOM_RIGHT) === LayoutItem.PANORAMA_VIEWER)
                        currentPlacement = LayoutPlace.BOTTOM_RIGHT;
                    break;

                case LayoutPlace.BOTTOM_LEFT:
                    if (getItem(oldLayoutContent, LayoutPlace.TOP_RIGHT) === LayoutItem.PANORAMA_VIEWER)
                        currentPlacement = LayoutPlace.TOP_RIGHT;
                    else if (getItem(oldLayoutContent, LayoutPlace.TOP_LEFT) === LayoutItem.PANORAMA_VIEWER)
                        currentPlacement = LayoutPlace.TOP_LEFT;
                    break;

                case LayoutPlace.BOTTOM_RIGHT:
                    if (getItem(oldLayoutContent, LayoutPlace.TOP_LEFT) === LayoutItem.PANORAMA_VIEWER)
                        currentPlacement = LayoutPlace.TOP_LEFT;
                    else if (getItem(oldLayoutContent, LayoutPlace.TOP_RIGHT) === LayoutItem.PANORAMA_VIEWER)
                        currentPlacement = LayoutPlace.TOP_RIGHT;
                    break;
                }
                if (!currentPlacement)
                    return oldLayoutContent;

                setItem(newData, newLayoutPlace, newLayoutItem);
                setItem(newData, currentPlacement, currentLayoutItem);
            }

            layoutContentRef.current = newData;

            return newData;
        });

    }, [setLayoutContent, setLayoutSelectOpen])


    const handleLayoutPlacementOpen = useCallback(layoutPlacementId => {
        if (!window.isTablet)
            return;

        const backdrop = document.getElementById("layout-select-backdrop");
        if (backdrop) {
            backdrop.style.display = "unset";
        }

        switch (layoutPlacementId) {
        case LayoutPlace.TOP_LEFT:
            setLayoutSelectOpen({
                topLeft:true,
                topRight:false,
                bottomLeft:false,
                bottomRight:false
            });
            break;
        case LayoutPlace.TOP_RIGHT:
            setLayoutSelectOpen({
                topLeft:false,
                topRight:true,
                bottomLeft:false,
                bottomRight:false
            });
            break;
        case LayoutPlace.BOTTOM_LEFT:
            setLayoutSelectOpen({
                topLeft:false,
                topRight:false,
                bottomLeft:true,
                bottomRight:false
            });
            break;
        case LayoutPlace.BOTTOM_RIGHT:
            setLayoutSelectOpen({
                topLeft:false,
                topRight:false,
                bottomLeft:false,
                bottomRight:true
            });
            break;
        }
    }, [setLayoutSelectOpen]);


    useEffect(() => {
        doResizeLayout(true, layoutContent)
    }, [layoutContent]);


    const doResizeLayout = (callResize, mapping) => {

        const LayoutPlacementToFrameMap = {}

        LayoutPlacementToFrameMap[LayoutPlace.TOP_LEFT] = 'c0r0frame';
        LayoutPlacementToFrameMap[LayoutPlace.TOP_RIGHT] = 'c1r0frame';
        LayoutPlacementToFrameMap[LayoutPlace.BOTTOM_LEFT] = 'c0r1frame';
        LayoutPlacementToFrameMap[LayoutPlace.BOTTOM_RIGHT] = 'c1r1frame';

        const findItem = (layoutContent, layoutItem) => {
            const result = [];
            if (layoutContent.topLeft === layoutItem)
                result.push(LayoutPlace.TOP_LEFT);
            if (layoutContent.topRight === layoutItem)
                result.push(LayoutPlace.TOP_RIGHT);
            if (layoutContent.bottomLeft === layoutItem)
                result.push(LayoutPlace.BOTTOM_LEFT);
            if (layoutContent.bottomRight === layoutItem)
                result.push(LayoutPlace.BOTTOM_RIGHT);
            return result.length === 0 ? '' :
                   result.length === 1 ? result[0] :
                   result
                ;
        }

        const emptyRect = new DOMRect(-8, -8, 8, 8);

        try {
            const planPlacement = findItem(mapping, LayoutItem.PLAN_VIEWER);
            const modelPlacement = findItem(mapping, LayoutItem.MODEL_VIEWER);
            const panoPlacement = findItem(mapping, LayoutItem.PANORAMA_VIEWER);

            const planFrameId = LayoutPlacementToFrameMap[planPlacement];
            const modelFrameId = LayoutPlacementToFrameMap[modelPlacement];
            const leftPanoFrameId = LayoutPlacementToFrameMap[panoPlacement[0]];
            const rightPanoFrameId = LayoutPlacementToFrameMap[panoPlacement[1]];


            const leftpanoframe = document.getElementById(leftPanoFrameId)?.getBoundingClientRect() ?? emptyRect;
            const rightframe = document.getElementById(rightPanoFrameId)?.getBoundingClientRect() ?? emptyRect;

            const adeskframe = document.getElementById(modelFrameId)?.getBoundingClientRect() ?? emptyRect;
            const planframe = document.getElementById(planFrameId)?.getBoundingClientRect() ?? emptyRect;

            const leftPano = document.getElementById('leftPano');
            if (leftPano) {
                leftPano.style.left = (leftpanoframe.left + 2) + 'px';
                leftPano.style.top = (leftpanoframe.top + 2) + 'px';
                leftPano.style.width = (leftpanoframe.width - 4) + 'px';
                leftPano.style.height = (leftpanoframe.height - 4) + 'px';
                if (callResize) {
                    suspendSyncingViewsRef.current = true;
                    leftPanoViewerRef.current?.getViewer().resize();
                    suspendSyncingViewsRef.current = false;
                }
            }

            const rightPano = document.getElementById('rightPano');
            if (rightPano) {
                rightPano.style.left = (rightframe.left + 2) + 'px';
                rightPano.style.top = (rightframe.top + 2) + 'px';
                rightPano.style.width = (rightframe.width - 4) + 'px';
                rightPano.style.height = (rightframe.height - 4) + 'px';
                if (callResize) {
                    suspendSyncingViewsRef.current = true;
                    rightPanoViewerRef.current?.getViewer().resize();
                    suspendSyncingViewsRef.current = false;
                }
            }

            const autodeskViewer = document.getElementById('viewer');
            if (autodeskViewer) {
                autodeskViewer.style.left = (adeskframe.left + 2) + 'px';
                autodeskViewer.style.top = (adeskframe.top + 2) + 'px';
                autodeskViewer.style.width = (adeskframe.width - 4) + 'px';
                autodeskViewer.style.height = (adeskframe.height - 4) + 'px';
                if (callResize) {
                    autodeskViewerRef.current?.resize();
                }
            }

            const planView = document.getElementById('planView');
            if (planView) {
                planView.style.left = (planframe.left + 2) + 'px';
                planView.style.top = (planframe.top + 2) + 'px';
                planView.style.width = (planframe.width - 4) + 'px';
                planView.style.height = (planframe.height - 4) + 'px';
                if (callResize) {
                    // planViewRef.current?.zoomExtents();
                    // window.frustum?.draw();
                }
                window.frustum?.draw();
            }
        }
        catch {}
    }


    useEffect(() => {
        if (!window.isTablet)
            return;

        if (!leftTimelineContainerRef.current)
            return ;
        if (!rightTimelineContainerRef.current)
            return ;

        const handleClick = (evt) => {
            if (evt?.target.id === "left-timeline") {
                setTimelineOpen( old => ({
                    left: true,
                    right: false
                }));
            }
            else if (evt?.target.id === "right-timeline") {
                setTimelineOpen( old => ({
                    left: false,
                    right: true
                }));
            }
        };

        leftTimelineContainerRef.current.addEventListener("click", handleClick);
        rightTimelineContainerRef.current.addEventListener("click", handleClick);

        return () => {
            if (!window.isTablet)
                return;
            leftTimelineContainerRef.current.removeEventListener("click", handleClick);
            rightTimelineContainerRef.current.removeEventListener("click", handleClick);
        }
    }, [leftPanoDocumentId, rightPanoDocumentId, isTimelineOpen, setTimelineOpen]);


    useEffect(() => {

        const interaction = evt => {

            //if (!autodeskViewerRef.current)
            //    return;
            if (!leftPanoViewerRef.current)
                return;

            if (evt instanceof WheelEvent) {
            }
            else if (evt instanceof MouseEvent) {
                // const camera = autodeskViewerRef.current.navigation.getCamera();
                // const vec = new THREE.Vector3();
                // const pos = new THREE.Vector3();
                //
                // vec.set(
                //     ( event.clientX / window.innerWidth ) * 2 - 1,
                //     - ( event.clientY / window.innerHeight ) * 2 + 1,
                //     0.5 );
                // vec.unproject( camera );
                // vec.sub( camera.position ).normalize();
                //
                // const distance = - camera.position.z / vec.z;
                // pos.copy( camera.position ).add( vec.multiplyScalar( distance ) );
                //
                // const tr = autodeskViewerRef.current.model.getInverseModelToViewerTransform();
                // pos.applyMatrix4(tr);
                //
                // console.log('at', pos)
                //
                // if (evt.type === 'mousedown') {
                //
                // }
                // else if (evt.type === 'mousemove') {
                //
                // }
                // else if (evt.type === 'mouseup') {
                //
                // }
            }
            else if (evt instanceof KeyboardEvent) {
                if (evt.type === 'keypress') {
                    // if (evt.code === "KeyL") {
                    //     if (!evt.altKey && !evt.shiftKey && !evt.ctrlKey) {
                    //         if (!leftPanoViewerRef.current)
                    //             return;
                    //         lockAutodeskViewer(old => !old);
                    //     }
                    // }
                }
                else if (evt.type === 'keydown') {
                    if (evt.code === "ArrowLeft" || evt.code === "ArrowRight") {
                        if (!dashboardDataRef.current.autodeskNavigationLocked)
                            return;
                        evt.preventDefault();

                        const panoViewer = leftPanoViewerRef.current.getViewer();
                        const d = evt.code === "ArrowLeft" ? -1.5 : 1.5;

                        let y = panoViewer.getYaw() + d;
                        if (y <= -180)
                            y = 360 + y;
                        else if (y > 180)
                            y = y - 360;

                        panoViewer.lookAt(
                            panoViewer.getPitch(),
                            y,
                            panoViewer.getHfov(),
                            false
                        );
                    }
                    else if (evt.code === "ArrowUp" || evt.code === "ArrowDown") {
                        if (!dashboardDataRef.current.autodeskNavigationLocked)
                            return;
                        evt.preventDefault();

                        const panoViewer = leftPanoViewerRef.current.getViewer();
                        const d = evt.code === "ArrowDown" ? -1.5 : 1.5;

                        let tpitch = panoViewer.getPitch() + d;
                        if (tpitch <= -70)
                            tpitch = 70;
                        else if (tpitch > 70)
                            tpitch = 70;

                        panoViewer.lookAt(
                            tpitch,
                            panoViewer.getYaw(),
                            panoViewer.getHfov(),
                            false
                        );
                    }
                }
            }
        }

        window.addEventListener('keydown', interaction);
        window.addEventListener('keyup', interaction);
        window.addEventListener('keypress', interaction);

        layoutHandleHammerRef.current = new Hammer(layoutHandleRef.current);
        layoutHandleHammerRef.current.get('pan').set({
            threshold: window.isTablet ? 8 : 2,
            direction: Hammer.DIRECTION_ALL
        });
        layoutHandleHammerRef.current.on("pan", onLayoutHandlePan);
        layoutHandleHammerRef.current.on("panend", onLayoutHandlePan);
        layoutHandleHammerRef.current.on("doubletap", onLayoutHandlePan);

        resizeObserverRef.current = new ResizeObserver((entries) => {
            doResizeLayout(false, layoutContentRef.current);
        });

        resizeObserverRef.current.observe(document.getElementById('c0r0frame'));
        resizeObserverRef.current.observe(document.getElementById('c0r1frame'));
        resizeObserverRef.current.observe(document.getElementById('c1r0frame'));
        resizeObserverRef.current.observe(document.getElementById('c1r1frame'));

        doResizeLayout(true, layoutContentRef.current);

        const windowSize = () => {
            const landscape = document.getElementById("landscape-warning");
            if (!landscape)
                return;

            if (window.innerWidth < window.innerHeight) {
                landscape.style.display = "flex";
            }
            else {
                landscape.style.display = "none";
            }
        };

        if (window.isTablet) {
            window.addEventListener('resize', windowSize);
            const backdrop = document.getElementById("layout-select-backdrop");
            if (backdrop) {
                backdrop.addEventListener("click", closeLayoutItemSelection);
            }
        }

        return () => {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;

            layoutHandleHammerRef.current.off("doubletap", onLayoutHandlePan);
            layoutHandleHammerRef.current.off("panend", onLayoutHandlePan);
            layoutHandleHammerRef.current.off("pan", onLayoutHandlePan);
            layoutHandleHammerRef.current = null;

            window.removeEventListener('keydown', interaction);
            window.removeEventListener('keyup', interaction);
            window.removeEventListener('keypress', interaction);

            if (window.isTablet) {
                window.addEventListener('resize', windowSize);
                const backdrop = document.getElementById("layout-select-backdrop");
                if (backdrop) {
                    backdrop.removeEventListener("click", closeLayoutItemSelection);
                }
            }
        }

    }, []);


    const onStartTour = useCallback((tourId, designDate, panoDate) => {
        try {
            const tour = tours.find(t => t.id === tourId);

            const designRoute = [];
            const panoRoute = [];

            for (const vpId of tour.definition.viewpoints) {
                const entry = tour.data[vpId][2].find(d => d.upload_at === panoDate);
                if (entry)
                    panoRoute.push(entry);
            }
            for (const vpId of tour.definition.viewpoints) {
                const entry = tour.data[vpId][3].find(d => d.upload_at === designDate);
                if (entry)
                    designRoute.push(entry);
            }

            if (designRoute.length > 1 && panoRoute.length > 1)
                startTourPlayer({
                    show: true,
                    tour,
                    designRoute: designRoute,
                    panoRoute: panoRoute,
                });
            else
                startTourPlayer({ show: false, designRoute: [], panoRoute: []});
        }
        catch {
            startTourPlayer({ show: false, designRoute: [], panoRoute: []});
        }
    }, [tours, startTourPlayer]);


    useEffect(() => {

    }, [ tourPlayer ])


    const projectSelectItems = props.projects.map(project => {
        const current = project.id === props.selectedProjectId;
        return (
            <ProjectSelectListItem
                key={project.id}
                selected={current}
                paddingVertical={window.isTablet ? 10 : 6}
                fontSize={window.isTablet ? '120%' : '100%'}
                onClick={() => {
                    if (!current)
                        setSelectedProjectId(project.id);
                    showSideBar(false);
                }}
            >
                {project.name}
            </ProjectSelectListItem>);
    });

    let panoTimelineItems = [];
    let designTimelineItems = [];
    let startDate = moment().format("YYYY-MM-DD");
    let endDate = moment().format("YYYY-MM-DD");

    if (selectedViewpointId > 0 && viewpointDocuments.length > 0) {

        const panoDocs =
            viewpointDocuments
                .filter(d => (d.category_id || 0) === 2)
                .sort((a, b) => {
                    const ad = new Date(a.upload_at);
                    const bd = new Date(b.upload_at);
                    return ad < bd ? -1 : ad > bd ? 1 : 0;
                });
        const designDocs =
            viewpointDocuments
                .filter(d => (d.category_id || 0) === 3)
                .sort((a, b) => {
                    const ad = new Date(a.upload_at);
                    const bd = new Date(b.upload_at);
                    return ad < bd ? -1 : ad > bd ? 1 : 0;
                });


        const panoIV = panoDocs.reduce((iv, pano) => {
            const d = new Date(pano.upload_at);
            const from = iv.from ? (d < iv.from ? d : iv.from) : d;
            const to = iv.to ? (d > iv.to ? d : iv.to) : d;
            return { from, to };
        }, { from:null, to:null });


        const designIV = designDocs.reduce((iv, pano) => {
            const d = new Date(pano.upload_at);
            const from = iv.from ? (d < iv.from ? d : iv.from) : d;
            const to = iv.to ? (d > iv.to ? d : iv.to) : d;
            return { from, to };
        }, { from:null, to:null });


        const timeLineIV = {
            from: panoIV.from,
            to: panoIV.to,
        };
        if (designIV.from) {
            if (timeLineIV.from === null || designIV.from < timeLineIV.from)
                timeLineIV.from = designIV.from;
        }
        if (designIV.to) {
            if (timeLineIV.to === null || designIV.to > timeLineIV.to)
                timeLineIV.to = designIV.to;
        }

        startDate = moment(timeLineIV.from).format("YYYY-MM-DD");
        endDate = moment(timeLineIV.to).format("YYYY-MM-DD");

        const timelineLength = Math.max(1, timeLineIV.to - timeLineIV.from);

        panoTimelineItems = panoDocs.map(d => ({
            ...TimelineItemTemplate,
            id:d.id,
            date:new Date(d.upload_at),
            position:(new Date(d.upload_at) - timeLineIV.from) / timelineLength,
            category:TimelineItemCategory.PANO
        }));

        designTimelineItems = designDocs.map(d => ({
            ...TimelineItemTemplate,
            id:d.id,
            date:new Date(d.upload_at),
            position:(new Date(d.upload_at) - timeLineIV.from) / timelineLength,
            category:TimelineItemCategory.DESIGN
        }));

        if (panoTimelineItems.length === 0)
            panoTimelineItems = designTimelineItems;
        else if (designTimelineItems.length === 0)
            designTimelineItems = panoTimelineItems;
    }

    const leftPanoTimelineItems = panoTimelineItems.map(i => ({...i, active:i.id === leftPanoDocumentId}));
    const leftDesignTimelineItems = designTimelineItems.map(i => ({...i, active:i.id === leftPanoDocumentId}));

    const rightPanoTimelineItems = panoTimelineItems.map(i => ({...i, active:i.id === rightPanoDocumentId}));
    const rightDesignTimelineItems = designTimelineItems.map(i => ({...i, active:i.id === rightPanoDocumentId}));


    const leftTimelines = (
        <>
            <TimelineContainer
                id="left-timeline"
                height={'88px'}
                ref={leftTimelineContainerRef}
                isOpen={isTimelineOpen.left}
                // style={{
                //     position:'absolute',
                //     left:'8px',
                //     top:'8px',
                //     width:'calc(100% - 16px)',
                //     height:'112px',
                //     zIndex:200,
                //     borderRadius:'4px',
                // }}
            >
                {/*<TimelineLegend*/}
                {/*    startDate={startDate}*/}
                {/*    endDate={endDate}*/}
                {/*/>*/}
                <TimelineHolder
                    //ref={leftDesignTimelineHolderRef}
                    style={{
                        position:'absolute',
                        left:'8px',
                        top:'8px',
                        width:'calc(100% - 16px)',
                        height:'32px',
                        zIndex:201,
                        //borderRadius:'12px',
                    }}
                >
                    <Timeline
                        kind={'design'}
                        toolTipPosition={'top'}
                        items={leftDesignTimelineItems}
                        startDate={startDate}
                        endDate={endDate}
                        onItemClick={ i => setLeftPanoDocumentId(i.id) }
                    />
                </TimelineHolder>
                <TimelineHolder
                    //ref={leftPanoTimelineHolderRef}
                    style={{
                        position:'absolute',
                        left:'8px',
                        top:'42px',
                        width:'calc(100% - 16px)',
                        height:'32px',
                        zIndex:201,
                        //borderRadius:'12px',
                    }}
                >
                    <Timeline
                        kind={'pano'}
                        toolTipPosition={'bottom'}
                        items={leftPanoTimelineItems}
                        startDate={startDate}
                        endDate={endDate}
                        onItemClick={ i => setLeftPanoDocumentId(i.id) }
                    />
                </TimelineHolder>
            </TimelineContainer>
        </>
    );


    const rightTimelines = (
        <>
            <TimelineContainer
                id="right-timeline"
                width={'calc(100% - 48px)'}
                height={'88px'}
                ref={rightTimelineContainerRef}
                isOpen={isTimelineOpen.right}
                // style={{
                //     position:'absolute',
                //     left:'8px',
                //     top:'8px',
                //     width:'calc(100% - 16px)',
                //     height:'112px',
                //     zIndex:200,
                //     borderRadius:'4px',
                // }}
            >
                {/*<TimelineLegend*/}
                {/*    startDate={startDate}*/}
                {/*    endDate={endDate}*/}
                {/*/>*/}
                <TimelineHolder
                    //ref={rightDesignTimelineHolderRef}
                    style={{
                        position:'absolute',
                        left:'8px',
                        top:'8px',
                        width:'calc(100% - 16px)',
                        height:'32px',
                        zIndex:201,
                        //borderRadius:'12px',
                    }}
                >
                    <Timeline
                        kind={'design'}
                        toolTipPosition={'top'}
                        items={rightDesignTimelineItems}
                        startDate={startDate}
                        endDate={endDate}
                        onItemClick={ i => setRightPanoDocumentId(i.id) }
                    />
                </TimelineHolder>
                <TimelineHolder
                    //ref={rightPanoTimelineHolderRef}
                    style={{
                        position:'absolute',
                        left:'8px',
                        top:'42px',
                        width:'calc(100% - 16px)',
                        height:'32px',
                        zIndex:201,
                        //borderRadius:'12px',
                    }}
                >
                    <Timeline
                        kind={'pano'}
                        toolTipPosition={'bottom'}
                        items={rightPanoTimelineItems}
                        startDate={startDate}
                        endDate={endDate}
                        onItemClick={ i => setRightPanoDocumentId(i.id) }
                    />
                </TimelineHolder>
            </TimelineContainer>
        </>
    );


    const c0WidthPct = numeral(layoutSplit.horizontal).format('0.000000%');
    const c1WidthPct = numeral(1 - layoutSplit.horizontal).format('0.000000%');
    const r0HeightPct = numeral(layoutSplit.vertical).format('0.000000%');
    const r1HeightPct = numeral(1 - layoutSplit.vertical).format('0.000000%');


    const leftPanoContent = leftPanoDocumentId > 0 ?
        (<>
            <Pannellum
                ref={leftPanoViewerRef}
                width="100%"
                height="100%"
                image={leftPanoDocumentObjURL}
                pitch={lastPitchRef.current}
                yaw={lastYawRef.current}
                hfov={90}
                vaov={180}
                friction={1.0}
                showFullscreenCtrl={false}
                showControls={false}
                keyboardZoom={false}
                disableKeyboardCtrl={true}
                doubleClickZoom={false}
                compass={false}
                autoLoad
                style={{flexGrow:1}}
                onRender={onLeftPanoramaRender}
                onLoad={() => {
                    URL.revokeObjectURL(leftPanoDocumentObjURL);
                    propagateHotSpots(leftPanoViewerRef.current, hotSpots);
                }}
            />
            {leftTimelines}
        </>) : null;


    const rightPanoContent = rightPanoDocumentId > 0 ?
        (<>
            <Pannellum
                ref={rightPanoViewerRef}
                width="100%"
                height="100%"
                image={rightPanoDocumentObjURL}
                pitch={lastPitchRef.current}
                yaw={lastYawRef.current}
                hfov={90}
                vaov={180}
                friction={1.0}
                showFullscreenCtrl={false}
                showControls={false}
                keyboardZoom={false}
                disableKeyboardCtrl={true}
                doubleClickZoom={false}
                compass={false}
                autoLoad
                style={{flexGrow:1}}
                onRender={onRightPanoramaRender}
                onLoad={() => {
                    URL.revokeObjectURL(rightPanoDocumentObjURL);

                    propagateHotSpots(rightPanoViewerRef.current, hotSpots);
                }}
            />
            {rightTimelines}
        </>) : null;


    const layerPaletteClassName=['dx-theme-background-color', 'dx-theme-accent-as-border-color'].join(' ');


    const onLayerPaletteButtonClick = useCallback(e => {
        keepalive();
        if (e.element.id === 'set_layer_visibility') {
            if (xHas(planDocumentCacheRef.current, planDocument?.pdfDocumentId)) {
                planDocumentCacheRef.current[planDocument.pdfDocumentId].pdfVisibleGroups = layerPalette.visibleLayerIds;
            }
            setPlanDocument(old => ({
                ...old,
                pdfVisibleGroups:layerPalette.visibleLayerIds
            }));
        }
        else if (e.element.id === 'show_all_layers') {
            setLayerPalette(old => ({
                ...old,
                visibleLayerIds:planDocument.pdfOptionalContentConfig.getOrder()
            }));
            if (xHas(planDocumentCacheRef.current, planDocument?.pdfDocumentId)) {
                planDocumentCacheRef.current[planDocument.pdfDocumentId].pdfVisibleGroups = [];
            }
            setPlanDocument(old => ({
                ...old,
                pdfVisibleGroups:[]
            }));
        }
        else if (e.element.id === 'layer_visibility_palette') {
            setLayerPalette(old => ({
                ...old,
                open:!old.open,
            }));
        }
    }, [ planDocument, setPlanDocument, layerPalette, setLayerPalette]);


    const onLayerSelectionChanged = useCallback(e => {
        if(e.name === 'selectedItemKeys') {
            setLayerPalette(old => ({
                ...old,
                visibleLayerIds:e.value
            }));
        }
    }, [setLayerPalette]);


    const layerPaletteElement =
        layerPalette.open
            ? <FloatingPaletteOpen top={layerPalette.top} left={layerPalette.left} width={320} className={layerPaletteClassName}>
                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems: 'center',
                    padding:2
                }}>
                    <Button
                        style={{flex:0}}
                        elementAttr={{
                            id:'layer_visibility_palette'
                        }}
                        focusStateEnabled={false}
                        icon={iconLayers}
                        stylingMode={'text'}
                        onClick={onLayerPaletteButtonClick}
                    />
                    <div style={{flex:1, padding:'0px 8px', pointerEvents:'none'}}>Layers</div>
                    <Button
                        style={{flex:0}}
                        elementAttr={{
                            id:'set_layer_visibility'
                        }}
                        hint={''}
                        focusStateEnabled={false}
                        icon={iconLayerCheck}
                        stylingMode={'text'}
                        onClick={onLayerPaletteButtonClick}
                    />
                    <span style={{flex:0,width:8}}/>
                    <Button
                        style={{flex:0}}
                        elementAttr={{
                            id:'show_all_layers'
                        }}
                        hint={'Show all'}
                        focusStateEnabled={false}
                        icon={iconLayerCheckAll}
                        stylingMode={'text'}
                        onClick={onLayerPaletteButtonClick}
                    />
                </div>
                <List
                    height={layerPalette.height}
                    items={layerPalette.layerList}
                    selectedItemKeys={layerPalette.visibleLayerIds}
                    keyExpr={'id'}
                    displayExpr={'name'}
                    selectionMode={"multiple"}
                    showScrollbar={"always"}
                    showSelectionControls
                    indicateLoading={false}
                    onOptionChanged={onLayerSelectionChanged}
                />
            </FloatingPaletteOpen>
            : <FloatingPaletteClosed top={layerPalette.top} left={layerPalette.left} className={layerPaletteClassName}>
                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems: 'center',
                    padding:2,
                    overflow: 'hidden'
                }}>
                    <Button
                        style={{flex:0}}
                        elementAttr={{
                            id:'layer_visibility_palette'
                        }}
                        focusStateEnabled={false}
                        icon={iconLayersOff}
                        hint={"Layers"}
                        stylingMode={'text'}
                        onClick={onLayerPaletteButtonClick}
                    />
                    <div style={{flex:1, padding:'0px 8px', pointerEvents:'none'}}>Layers</div>
                </div>
            </FloatingPaletteClosed>
    ;


    const renderPlanFileName = (file, { handleClick }) => {
        const text = `${file.name}`;
        return (
            <BpMenuItem
                key={file.id}
                onClick={handleClick}
                text={text}
            />
        );
    };


    const selectedPlanItem = (selectedProjectPlans || []).find(p => p.id === showPlanId);
    const selectedPlanName = selectedPlanItem ? selectedPlanItem.name : "select a file";

    const planViewContent = planDocument ?
        (<>
            <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <PlanViewAdvanced
                    ref={planViewRef}
                    pdfPage={planDocument.pdfPage}
                    pdfPageViewport={planDocument.pdfPageViewport}
                    pdfOptionalContentConfig={planDocument.pdfOptionalContentConfig}
                    pdfVisibleGroups={planDocument.pdfVisibleGroups}
                    pdfViewpoints={planDocument.pdfViewpoints}
                    pdfTransform={planDocument.pdfTransform}
                    pdfActiveTool={null}
                    setActiveTool={null}
                    actAsViewpointSelector={true}
                    backgroundColor={'white'}
                    width={'100%'}
                    height={'100%'}
                    showStatusBar={false}
                    showCoords={false}
                    followSelected={true}
                    zIndexBase={200}
                />
                <div style={{
                    width: '100%',
                    height: 'auto',
                    zIndex: 200,
                    padding: 4,
                    display:'flex',
                    flexDirection: 'row',
                    flex:0
                }} className={layerPaletteClassName}>
                    <BpSelect
                        items={selectedProjectPlans}
                        itemRenderer={renderPlanFileName}
                        filterable={false}
                        popoverProps={{
                            minimal:true
                        }}
                        disabled={(selectedProjectPlans || []).length < 2}
                        onItemSelect={p => setShowPlanId(p.id)}
                    >
                        <BpButton
                            style={{marginRight:8, minWidth: 256}}
                            rightIcon={"caret-down"}
                            alignText={BP_ALIGNMENT.LEFT}
                            disabled={(selectedProjectPlans || []).length < 2}
                            text={selectedPlanName}
                        />
                    </BpSelect>
                    <div style={{width:8}}/>
                    {window.isDesktop &&
                    <BpTooltip
                        content={'Zoom Extents'}
                        hoverOpenDelay={400}
                    >
                        <BpButton
                            onClick={() => planViewRef.current?.zoomExtents()}
                        >
                            <SVG src={zoomExtentsIcon}/>
                        </BpButton>
                    </BpTooltip>
                    }
                    {window.isTablet &&
                    <BpButton
                        onClick={() => planViewRef.current?.zoomExtents()}
                    >
                        <SVG src={zoomExtentsIcon}/>
                    </BpButton>
                    }
                    <div style={{width:8}}/>
                    <BpButton
                        icon={IconNames.REFRESH}
                        onClick={() => planViewRef.current?.rerender()}
                    />
                </div>
            </div>
            {layerPaletteElement}
        </>)
        : null;


    const autodeskViewerContent =(
        <div id="viewer" style={{
            position:'absolute',
            left:0, top:0,
            right: 0, bottom:0
        }}>
        </div>);

    const autodeskViewerLocker = (
        <div id={'toolbox'} style={{
            position: 'absolute',
            left:8,
            bottom:8,
            // top:r0HeightPct,
            backgroundColor:'rgba(0,0,0,0.9)',
            border:'2px solid rgba(96,96,96,1)',
            width:40,
            height:40,
            zIndex:800,
            borderRadius:4,
            //transform:'translate(0%,-50%)',
            display:'flex',
            flexDirection:'column',
            padding:6
        }}>
            <Icon icon={isAutodeskViewerLocked ? IconNames.LOCK : IconNames.UNLOCK}
                  iconSize={24}
                  color={'rgba(96,96,96,1)'}
                  onClick={ onLockAutodeskViewerClicked }
                  style={{ cursor: 'pointer' }} />
        </div>
    );

    const hasPanorama = leftPanoDocumentId > 0 && rightPanoDocumentId > 0;
    const hasModel = selectedProjectId > 0;

    const layoutHandleSize = window.isTablet ? 32 : 16;

    const sideBarGeom = window.isTablet
        ? {
            width : 48,
            buttonSize : 32,
            iconSize : 24,
            padding : 8,
        }
        : {
            width : 40,
            buttonSize : 32,
            iconSize : 20,
            padding: 4,
        }
    ;

    return (
        <>
            {tours.length > 0 && isTourOptionsVisible &&
                <TourPlayOptionsDialog
                    tours={tours}
                    onClose={() => showTourOptions(false)}
                    onPlayTour={(tourId, imageType, date) => {
                        showTourOptions(false);
                        onStartTour(tourId, imageType, date);
                    }}
                />
            }

            {tourPlayer.show &&
                <TourPlayer
                    tour={tourPlayer.tour}
                    designRoute={tourPlayer.designRoute}
                    panoRoute={tourPlayer.panoRoute}
                    zIndexBase={2000}
                    finished={() => {
                        startTourPlayer({ show:false, designRoute:[], panoRoute:[] })
                    }}
                />
            }

            <div id={'layoutHandle'} ref={layoutHandleRef} style={{
                position: 'absolute',
                left:c0WidthPct,
                top:r0HeightPct,
                backgroundColor:'rgba(255,92,0,0.5)',
                width:`${layoutHandleSize}px`,
                height:`${layoutHandleSize}px`,
                zIndex:800,
                borderRadius:`${layoutHandleSize/2}px`,
                transform:'translate(-50%,-50%)',
                cursor: 'move',
            }}/>

            <div id="leftPano" style={{ position:'absolute', left:0, top:0, right: 0, bottom:0, zIndex:10 }}>
                {leftPanoContent}
            </div>

            <div id="rightPano" style={{ position:'absolute', left:0, top:0, right: 0, bottom:0, zIndex:10 }}>
                {rightPanoContent}
            </div>

            {autodeskViewerContent}

            <div id="planView" style={{ position:'absolute', left:0, top:0, right: 0, bottom:0 }}>
                {planViewContent}
            </div>

            <div style={{ position:'absolute', left: 0, top: 0, right:0, bottom:0 }}>
                <div style={{ position:'absolute', left: 0, top: 0, width:c0WidthPct, bottom:0 }}>
                    <div id={'c0r0frame'}
                         className={'dx-theme-border-color'}
                         style={{
                            position:'absolute',
                            left: 0,
                            top: 0,
                            right:0,
                            height:r0HeightPct,
                            border:'2px solid',
                    }}>
                        <LayoutItemSelect
                            id={LayoutPlace.TOP_LEFT}
                            isOpen={isLayoutSelectOpen.topLeft}
                            top={layoutContent.topLeft === LayoutItem.PANORAMA_VIEWER && hasPanorama ? '40px' : '8px'}
                            activeItem={layoutContent.topLeft}
                            onLayoutItemClick={handleLayoutItemSelection}
                            onLayoutContainerClick={() => handleLayoutPlacementOpen(LayoutPlace.TOP_LEFT)}
                        />
                        { layoutContent.topLeft === LayoutItem.MODEL_VIEWER && hasModel && autodeskViewerLocker }
                    </div>
                    <div id={'c0r1frame'}
                        className={'dx-theme-border-color'} style={{
                        position:'absolute',
                        left: 0,
                        right: 0,
                        bottom:0,
                        height:r1HeightPct,
                        border:'2px solid',
                    }}>
                        <LayoutItemSelect
                            id={LayoutPlace.BOTTOM_LEFT}
                            isOpen={isLayoutSelectOpen.bottomLeft}
                            top={layoutContent.bottomLeft === LayoutItem.PANORAMA_VIEWER && hasPanorama ? '40px' : '8px'}
                            activeItem={layoutContent.bottomLeft}
                            onLayoutItemClick={handleLayoutItemSelection}
                            onLayoutContainerClick={() => handleLayoutPlacementOpen(LayoutPlace.BOTTOM_LEFT)}
                        />
                        { layoutContent.bottomLeft === LayoutItem.MODEL_VIEWER && hasModel && autodeskViewerLocker }
                    </div>
                </div>
                <div style={{ position:'absolute', right: 0, top: 0, width:c1WidthPct, bottom:0 }}>
                    <div id={'c1r0frame'}
                         className={'dx-theme-border-color'} style={{
                        position:'absolute',
                        left: 0,
                        top: 0,
                        right:0,
                        height:r0HeightPct,
                        border:'2px solid',
                    }}>
                        <LayoutItemSelect
                            id={LayoutPlace.TOP_RIGHT}
                            isOpen={isLayoutSelectOpen.topRight}
                            top={layoutContent.topRight === LayoutItem.PANORAMA_VIEWER && hasPanorama ? '40px' : '8px'}
                            activeItem={layoutContent.topRight}
                            onLayoutItemClick={handleLayoutItemSelection}
                            onLayoutContainerClick={() => handleLayoutPlacementOpen(LayoutPlace.TOP_RIGHT)}
                        />
                        { layoutContent.topRight === LayoutItem.MODEL_VIEWER && hasModel && autodeskViewerLocker }
                    </div>
                    <div id={'c1r1frame'}
                         className={'dx-theme-border-color'} style={{
                        position:'absolute',
                        left: 0,
                        right: 0,
                        bottom:0,
                        height:r1HeightPct,
                        border:'2px solid',
                    }}>
                        <LayoutItemSelect
                            id={LayoutPlace.BOTTOM_RIGHT}
                            isOpen={isLayoutSelectOpen.bottomRight}
                            left={`${layoutHandleSize/2}px`}
                            top={layoutContent.bottomRight === LayoutItem.PANORAMA_VIEWER && hasPanorama
                                ? `${32+layoutHandleSize/2}px` : `${layoutHandleSize/2}px`}
                            activeItem={layoutContent.bottomRight}
                            onLayoutItemClick={handleLayoutItemSelection}
                            onLayoutContainerClick={() => handleLayoutPlacementOpen(LayoutPlace.BOTTOM_RIGHT)}
                        />
                        { layoutContent.bottomRight === LayoutItem.MODEL_VIEWER && hasModel && autodeskViewerLocker }
                    </div>
                </div>
            </div>

            {/*<editor-fold desc="Sidebar">*/}
            { !isSideBarVisible &&
            <SideBarBase style={{
                position:'absolute',
                top: 0, right:0, bottom:0,
                width: sideBarGeom.width,
                zIndex:300
            }}>
                <SizeButton style={{
                    position:'absolute',
                    right: sideBarGeom.padding,
                    top: sideBarGeom.padding,
                    width: sideBarGeom.buttonSize,
                    height: sideBarGeom.buttonSize,
                    color:'rgba(0,0,0,0.5)'
                }}>
                    <Icon
                        icon={IconNames.MENU}
                        iconSize={sideBarGeom.iconSize}
                        onClick={() => showSideBar(true)}
                    />
                    {window.isDesktop &&
                    <ToolTip>Select project</ToolTip>
                    }
                </SizeButton>
                {
                    screenfull.isEnabled && // window.isTablet &&
                    <SizeButton style={{
                        position:'absolute',
                        right: sideBarGeom.padding,
                        top: sideBarGeom.padding*2+sideBarGeom.buttonSize,
                        width: sideBarGeom.buttonSize,
                        height: sideBarGeom.buttonSize,
                        color:'rgba(0,0,0,0.5)'
                    }}>
                        <Icon
                            icon={IconNames.FULLSCREEN}
                            iconSize={sideBarGeom.iconSize}
                            onClick={() => screenfull.toggle()}
                        />
                        {window.isDesktop &&
                        <ToolTip>Switch to fullscreen</ToolTip>
                        }
                    </SizeButton>
                }
                <SizeButton style={{
                    position:'absolute',
                    right: sideBarGeom.padding,
                    top: sideBarGeom.padding*3+sideBarGeom.buttonSize*2,
                    width: sideBarGeom.buttonSize,
                    height: sideBarGeom.buttonSize,
                    color:'rgba(0,0,0,0.5)'
                }}>
                    <Icon
                        icon={IconNames.WALK}
                        iconSize={sideBarGeom.iconSize}
                        onClick={() => {
                            if (tours.length === 0)
                                AppToaster.show({
                                    message:'There are no tours to walkthrough.',
                                    intent:Intent.WARNING,
                                });
                            else
                                showTourOptions(true)
                        }}
                    />
                    {window.isDesktop &&
                    <ToolTip>Tour</ToolTip>
                    }
                </SizeButton>
            </SideBarBase>
            }
            {/*</editor-fold>*/}
            {/*<editor-fold desc="Project selector">*/}
            <Drawer canOutsideClickClose={false}
                    size={384}
                    isOpen={isSideBarVisible}
                    title={'Projects'}
                    position={Position.RIGHT}
                    onClose={() => showSideBar(false)}
            >
                <ProjectSelectList>
                    {projectSelectItems}
                </ProjectSelectList>
            </Drawer>
            {/*</editor-fold>*/}
        </>
    );
}


function App(props) {

    const { user } = useAuth();

    if (!user) {

        if (window.isTablet) {
            if (screenfull.isEnabled && screenfull.isFullscreen) {
                screenfull.exit();
            }
        }

        return (<LoginForm />);
    }

    return (
        <PlanviewContextProvider>
            <AppInner {...props} />
        </PlanviewContextProvider>
    );
}


const mapStateToProps = (state) => ({
    projects: getProjects(state),
    selectedProjectId: getSelectedProjectId(state),
    selectedProjectPlans: getSelectedProjectPlans(state),
    showPlanId: showPlanId(state),
});

const mapDispatchToProps = {
    setProjects,
    setSelectedProjectId,
    setSelectedProjectPlans,
    setShowPlanId
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(App);


/*
*
* EXTENSION_LOADED_EVENT
* EXTENSION_UNLOADED_EVENT

 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.AGGREGATE_FIT_TO_VIEW_EVENT,
 evt => console.log('AGGREGATE_FIT_TO_VIEW_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.AGGREGATE_HIDDEN_CHANGED_EVENT,
 evt => console.log('AGGREGATE_HIDDEN_CHANGED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.AGGREGATE_ISOLATION_CHANGED_EVENT,
 evt => console.log('AGGREGATE_ISOLATION_CHANGED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT,
 evt => console.log('AGGREGATE_SELECTION_CHANGED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.ANIMATION_READY_EVENT,
 evt => console.log('ANIMATION_READY_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.CAMERA_CHANGE_EVENT,
 evt => console.log('CAMERA_CHANGE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.CUTPLANES_CHANGE_EVENT,
 evt => console.log('CUTPLANES_CHANGE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.ESCAPE_EVENT,
 evt => console.log('ESCAPE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.EXPLODE_CHANGE_EVENT,
 evt => console.log('EXPLODE_CHANGE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.EXTENSION_ACTIVATED_EVENT,
 evt => console.log('EXTENSION_ACTIVATED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.EXTENSION_DEACTIVATED_EVENT,
 evt => console.log('EXTENSION_DEACTIVATED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.EXTENSION_LOADED_EVENT,
 evt => console.log('EXTENSION_LOADED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.EXTENSION_PRE_ACTIVATED_EVENT,
 evt => console.log('EXTENSION_PRE_ACTIVATED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.EXTENSION_PRE_DEACTIVATED_EVENT,
 evt => console.log('EXTENSION_PRE_DEACTIVATED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.EXTENSION_PRE_LOADED_EVENT,
 evt => console.log('EXTENSION_PRE_LOADED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.EXTENSION_PRE_UNLOADED_EVENT,
 evt => console.log('EXTENSION_PRE_UNLOADED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.EXTENSION_UNLOADED_EVENT,
 evt => console.log('EXTENSION_UNLOADED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.FINAL_FRAME_RENDERED_CHANGED_EVENT,
 evt => console.log('FINAL_FRAME_RENDERED_CHANGED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.FIT_TO_VIEW_EVENT,
 evt => console.log('FIT_TO_VIEW_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.FULLSCREEN_MODE_EVENT,
 evt => console.log('FULLSCREEN_MODE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
 evt => console.log('GEOMETRY_LOADED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.HIDE_ALL_EVENT,
 evt => console.log('HIDE_ALL_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.HIDE_EVENT,
 evt => console.log('HIDE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.HYPERLINK_EVENT,
 evt => console.log('HYPERLINK_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.ISOLATE_EVENT,
 evt => console.log('ISOLATE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.LAYER_VISIBILITY_CHANGED_EVENT,
 evt => console.log('LAYER_VISIBILITY_CHANGED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.LOADER_LOAD_ERROR_EVENT,
 evt => console.log('LOADER_LOAD_ERROR_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.LOADER_LOAD_FILE_EVENT,
 evt => console.log('LOADER_LOAD_FILE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.MODEL_ADDED_EVENT,
 evt => console.log('MODEL_ADDED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.MODEL_LAYERS_LOADED_EVENT,
 evt => console.log('MODEL_LAYERS_LOADED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.MODEL_REMOVED_EVENT,
 evt => console.log('MODEL_REMOVED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.MODEL_ROOT_LOADED_EVENT,
 evt => console.log('MODEL_ROOT_LOADED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.MODEL_TRANSFORM_CHANGED_EVENT,
 evt => console.log('MODEL_TRANSFORM_CHANGED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.MODEL_UNLOADED_EVENT,
 evt => console.log('MODEL_UNLOADED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.NAVIGATION_MODE_CHANGED_EVENT,
 evt => console.log('NAVIGATION_MODE_CHANGED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT,
 evt => console.log('OBJECT_TREE_CREATED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.OBJECT_TREE_LOAD_PROGRESS_EVENT,
 evt => console.log('OBJECT_TREE_LOAD_PROGRESS_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.OBJECT_TREE_UNAVAILABLE_EVENT,
 evt => console.log('OBJECT_TREE_UNAVAILABLE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.PREF_CHANGED_EVENT,
 evt => console.log('PREF_CHANGED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.PREF_RESET_EVENT,
 evt => console.log('PREF_RESET_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.PROFILE_CHANGE_EVENT,
 evt => console.log('PROFILE_CHANGE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.PROFILE_CHANGE_EVENT,
 evt => console.log('PROFILE_CHANGE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.PROGRESS_UPDATE_EVENT,
 evt => console.log('PROGRESS_UPDATE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.RENDER_OPTION_CHANGED_EVENT,
 evt => console.log('RENDER_OPTION_CHANGED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.RENDER_PRESENTED_EVENT,
 evt => console.log('RENDER_PRESENTED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.RESTORE_DEFAULT_SETTINGS_EVENT,
 evt => console.log('RESTORE_DEFAULT_SETTINGS_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.SELECTION_CHANGED_EVENT,
 evt => console.log('SELECTION_CHANGED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.SET_VIEW_EVENT,
 evt => console.log('SET_VIEW_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.SETTINGS_PANEL_CREATED_EVENT,
 evt => console.log('SETTINGS_PANEL_CREATED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.SHOW_ALL_EVENT,
 evt => console.log('SHOW_ALL_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.SHOW_EVENT,
 evt => console.log('SHOW_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.SHOW_PROPERTIES_EVENT,
 evt => console.log('SHOW_PROPERTIES_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.TEXTURES_LOADED_EVENT,
 evt => console.log('TEXTURES_LOADED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.TOOL_CHANGE_EVENT,
 evt => console.log('TOOL_CHANGE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.TOOLBAR_CREATED_EVENT,
 evt => console.log('TOOLBAR_CREATED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.VIEW_CUBE_CREATED_EVENT,
 evt => console.log('VIEW_CUBE_CREATED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.VIEWER_RESIZE_EVENT,
 evt => console.log('VIEWER_RESIZE_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.VIEWER_STATE_RESTORED_EVENT,
 evt => console.log('VIEWER_STATE_RESTORED_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.WEBGL_CONTEXT_LOST_EVENT,
 evt => console.log('WEBGL_CONTEXT_LOST_EVENT', evt));
 autodeskViewerRef.current.addEventListener(
 Autodesk.Viewing.WEBGL_CONTEXT_RESTORED_EVENT,
 evt => console.log('WEBGL_CONTEXT_RESTORED_EVENT', evt));


*/

/*
 displayName: "Anson Sun Plaza - Bukarest Panorama.rvt"
 id: "urn:adsk.wipemea:dm.lineage:R4U9GlGcReahzbvLLy0OgA"

 displayName: "Auchan Obuda R20 butor 2.rvt"
 id: "urn:adsk.wipemea:dm.lineage:eC5C5Cz6QMKkN-2B6JlyKg"

 displayName: "Auchan Obuda R20 butor.rvt"
 id: "urn:adsk.wipemea:dm.lineage:3XuntuAdRaCx7idSLdCmoA"

 displayName: "Auchan Obuda R20_detached.rvt"
 id: "urn:adsk.wipemea:dm.lineage:j0NKSG5rRWiVQf5uM1FxGg"

 displayName: "P&C - ETELE_detached.rvt"
 id: "urn:adsk.wipemea:dm.lineage:aXjp0B26TxSr8-uMwXC68A"

 displayName: "P&C - ETELE_detached with furniture.rvt"
 id: "urn:adsk.wipemea:dm.lineage:Vo5aGEvQSV6J-7-IBsLEnA"

 */
